var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _g2, _g3, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 347,
    height: 339,
    viewBox: "0 0 347 339",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M313.299 296.617C315.273 273.745 271.085 250.479 214.602 244.65C158.119 238.821 110.73 252.636 108.756 275.508C106.782 298.38 150.97 321.646 207.453 327.475C263.936 333.304 311.325 319.488 313.299 296.617Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.039,
    d: "M311.379 296.287C313.327 273.719 269.834 250.773 214.235 245.035C158.635 239.297 111.984 252.941 110.037 275.508C108.089 298.076 151.582 321.022 207.181 326.76C262.78 332.498 309.431 318.854 311.379 296.287Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.059,
    d: "M309.464 295.957C311.385 273.694 268.586 251.068 213.87 245.421C159.153 239.774 113.238 253.245 111.317 275.508C109.395 297.772 152.194 320.398 206.911 326.045C261.628 331.691 307.542 318.221 309.464 295.957Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.078,
    d: "M307.551 295.628C309.447 273.668 267.342 251.363 213.507 245.807C159.673 240.251 114.495 253.549 112.599 275.509C110.704 297.468 152.809 319.774 206.643 325.329C260.478 330.885 305.656 317.587 307.551 295.628Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.098,
    d: "M305.53 295.354C307.405 273.709 266.02 251.717 213.093 246.235C160.166 240.753 115.741 253.857 113.866 275.502C111.991 297.148 153.376 319.139 206.303 324.621C259.23 330.103 303.655 317 305.53 295.354Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.118,
    d: "M303.616 295.026C305.465 273.684 264.773 252.013 212.728 246.623C160.684 241.232 116.994 254.163 115.146 275.505C113.297 296.846 153.989 318.517 206.034 323.908C258.078 329.298 301.768 316.368 303.616 295.026Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.137,
    d: "M301.7 294.692C303.523 273.653 263.526 252.302 212.364 247.002C161.202 241.703 118.25 254.463 116.428 275.502C114.605 296.541 154.603 317.893 205.764 323.192C256.926 328.491 299.878 315.731 301.7 294.692Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.157,
    d: "M299.787 294.364C301.583 273.628 262.28 252.598 212 247.39C161.72 242.182 119.504 254.769 117.708 275.505C115.912 296.24 155.216 317.271 205.495 322.479C255.775 327.686 297.991 315.099 299.787 294.364Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.176,
    d: "M297.871 294.035C299.641 273.604 261.032 252.893 211.635 247.777C162.239 242.661 120.76 255.076 118.99 275.507C117.22 295.939 155.829 316.649 205.226 321.765C254.622 326.882 296.101 314.466 297.871 294.035Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.196,
    d: "M295.955 293.635C297.697 273.507 259.78 253.121 211.264 248.102C162.749 243.082 122.008 255.33 120.267 275.458C118.525 295.585 156.443 315.971 204.958 320.991C253.473 326.01 294.214 313.762 295.955 293.635Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.216,
    d: "M294.044 293.307C295.759 273.483 258.536 253.417 210.902 248.489C163.269 243.561 123.264 255.636 121.549 275.46C119.834 295.284 157.058 315.349 204.691 320.277C252.324 325.206 292.329 313.13 294.044 293.307Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.235,
    d: "M292.128 292.978C293.817 273.458 257.288 253.713 210.538 248.877C163.788 244.04 124.521 255.943 122.832 275.463C121.143 294.982 157.672 314.727 204.422 319.564C251.172 324.401 290.439 312.498 292.128 292.978Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.255,
    d: "M290.19 292.606C291.851 273.39 256.014 253.97 210.145 249.229C164.277 244.489 125.747 256.224 124.086 275.44C122.425 294.656 158.262 314.077 204.131 318.817C249.999 323.557 288.53 311.822 290.19 292.606Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.275,
    d: "M288.277 292.281C289.911 273.368 254.768 254.268 209.783 249.619C164.798 244.97 127.005 256.533 125.37 275.445C123.736 294.357 158.878 313.457 203.864 318.106C248.849 322.755 286.642 311.193 288.277 292.281Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.294,
    d: "M286.366 291.953C287.974 273.343 253.525 254.562 209.422 250.005C165.318 245.447 128.262 256.838 126.653 275.448C125.045 294.057 159.494 312.838 203.597 317.396C247.7 321.954 284.757 310.563 286.366 291.953Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.314,
    d: "M284.426 291.588C286.007 273.282 252.251 254.824 209.03 250.362C165.81 245.899 129.491 257.122 127.91 275.428C126.33 293.734 160.086 312.191 203.306 316.653C246.527 321.116 282.845 309.894 284.426 291.588Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M282.517 291.263C284.071 273.261 251.009 255.124 208.67 250.752C166.332 246.381 130.749 257.431 129.195 275.433C127.641 293.435 160.703 311.572 203.041 315.943C245.38 320.315 280.962 309.265 282.517 291.263Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.353,
    d: "M280.607 290.94C282.136 273.242 249.767 255.425 208.311 251.145C166.854 246.865 132.008 257.742 130.48 275.44C128.951 293.138 161.32 310.955 202.776 315.235C244.233 319.516 279.079 308.639 280.607 290.94Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.373,
    d: "M278.668 290.573C280.168 273.179 248.493 255.686 207.919 251.501C167.345 247.317 133.237 258.026 131.737 275.42C130.236 292.814 161.912 310.307 202.485 314.492C243.059 318.677 277.167 307.968 278.668 290.573Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.392,
    d: "M276.761 290.251C278.235 273.161 247.253 255.988 207.561 251.894C167.869 247.801 134.498 258.337 133.024 275.427C131.549 292.518 162.531 309.691 202.223 313.784C241.915 317.878 275.287 307.342 276.761 290.251Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.412,
    d: "M274.823 289.888C276.269 273.101 245.981 256.252 207.172 252.254C168.363 248.256 135.729 258.623 134.283 275.41C132.837 292.197 163.125 309.046 201.934 313.044C240.743 317.042 273.377 306.675 274.823 289.888Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.431,
    d: "M272.916 289.566C274.337 273.082 244.742 256.552 206.815 252.645C168.888 248.737 136.99 258.933 135.57 275.417C134.15 291.901 163.745 308.432 201.672 312.339C239.599 316.246 271.496 306.051 272.916 289.566Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.451,
    d: "M270.979 289.209C272.372 273.029 243.47 256.821 206.426 253.009C169.382 249.196 138.223 259.222 136.83 275.402C135.437 291.583 164.338 307.79 201.383 311.603C238.427 315.416 269.586 305.39 270.979 289.209Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.471,
    d: "M269.075 288.893C270.441 273.016 242.234 257.129 206.071 253.407C169.909 249.685 139.486 259.538 138.119 275.415C136.753 291.291 164.96 307.179 201.123 310.901C237.285 314.623 267.708 304.769 269.075 288.893Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M267.144 288.534C268.483 272.962 240.968 257.397 205.687 253.77C170.406 250.143 140.72 259.827 139.381 275.4C138.042 290.972 165.558 306.537 200.838 310.164C236.119 313.791 265.805 304.107 267.144 288.534Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M265.237 288.22C266.55 272.952 239.729 257.707 205.332 254.171C170.935 250.635 141.986 260.146 140.673 275.414C139.36 290.683 166.18 305.928 200.578 309.464C234.975 313 263.924 303.489 265.237 288.22Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.529,
    d: "M263.368 287.922C264.66 272.951 238.527 258.01 204.998 254.55C171.47 251.09 143.242 260.421 141.95 275.392C140.658 290.362 166.791 305.304 200.319 308.764C233.848 312.224 262.075 302.893 263.368 287.922Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.549,
    d: "M261.41 287.452C262.662 272.785 237.214 258.194 204.569 254.861C171.924 251.528 144.444 260.715 143.192 275.382C141.94 290.049 167.388 304.64 200.033 307.973C232.678 311.307 260.158 302.119 261.41 287.452Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.569,
    d: "M259.45 287.165C260.68 272.806 235.939 258.528 204.188 255.274C172.437 252.021 145.7 261.023 144.469 275.382C143.238 289.741 167.98 304.018 199.731 307.272C231.482 310.526 258.219 301.524 259.45 287.165Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.588,
    d: "M257.548 286.859C258.753 272.804 234.706 258.846 203.838 255.683C172.97 252.52 146.97 261.349 145.766 275.404C144.561 289.459 168.608 303.417 199.476 306.58C230.343 309.744 256.343 300.914 257.548 286.859Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.608,
    d: "M255.65 286.485C256.827 272.734 233.473 259.099 203.487 256.03C173.501 252.961 148.238 261.621 147.061 275.372C145.884 289.123 169.238 302.758 199.224 305.827C229.211 308.896 254.473 300.236 255.65 286.485Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.627,
    d: "M253.729 286.146C254.879 272.698 232.218 259.385 203.113 256.409C174.009 253.433 149.483 261.922 148.333 275.369C147.183 288.816 169.845 302.13 198.949 305.106C228.054 308.082 252.58 299.593 253.729 286.146Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.647,
    d: "M251.806 285.807C252.928 272.663 230.961 259.672 202.739 256.79C174.518 253.907 150.73 262.226 149.607 275.369C148.484 288.513 170.452 301.504 198.674 304.386C226.895 307.269 250.683 298.95 251.806 285.807Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M249.923 285.478C251.02 272.634 229.739 259.959 202.39 257.166C175.041 254.374 151.982 262.522 150.885 275.366C149.789 288.21 171.07 300.886 198.418 303.678C225.767 306.47 248.826 298.322 249.923 285.478Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.686,
    d: "M247.944 285.105C249.011 272.569 228.429 260.223 201.972 257.53C175.515 254.836 153.203 262.815 152.135 275.351C151.068 287.887 171.65 300.233 198.107 302.927C224.564 305.62 246.877 297.641 247.944 285.105Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.706,
    d: "M246.067 284.816C247.112 272.58 227.22 260.544 201.637 257.932C176.055 255.32 154.469 263.121 153.424 275.357C152.379 287.593 172.271 299.629 197.854 302.241C223.436 304.853 245.022 297.052 246.067 284.816Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.725,
    d: "M244.111 284.377C245.119 272.443 225.913 260.747 201.214 258.253C176.515 255.758 155.676 263.409 154.667 275.342C153.659 287.276 172.865 298.972 197.564 301.466C222.263 303.961 243.103 296.31 244.111 284.377Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.745,
    d: "M242.188 284.11C243.174 272.484 224.67 261.103 200.86 258.69C177.05 256.276 156.949 263.745 155.963 275.37C154.978 286.996 173.481 298.378 197.291 300.791C221.101 303.204 241.202 295.736 242.188 284.11Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.765,
    d: "M240.29 283.738C241.248 272.416 223.437 261.357 200.508 259.039C177.58 256.72 158.216 264.019 157.258 275.341C156.301 286.663 174.112 297.721 197.04 300.04C219.969 302.359 239.333 295.06 240.29 283.738Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.784,
    d: "M238.364 283.402C239.294 272.384 222.176 261.648 200.13 259.423C178.085 257.198 159.459 264.327 158.529 275.345C157.599 286.364 174.717 297.1 196.763 299.324C218.808 301.549 237.434 294.421 238.364 283.402Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.804,
    d: "M236.446 283.069C237.351 272.352 220.924 261.931 199.756 259.793C178.587 257.655 160.693 264.609 159.788 275.326C158.882 286.043 175.309 296.464 196.477 298.602C217.646 300.74 235.54 293.786 236.446 283.069Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.823,
    d: "M234.519 282.69C235.389 272.277 219.65 262.193 199.365 260.166C179.08 258.14 161.931 264.938 161.061 275.351C160.191 285.764 175.93 295.848 196.215 297.875C216.499 299.901 233.649 293.103 234.519 282.69Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.843,
    d: "M232.585 282.392C233.43 272.284 218.389 262.518 198.99 260.577C179.59 258.636 163.178 265.257 162.333 275.364C161.487 285.471 176.528 295.238 195.928 297.179C215.327 299.119 231.739 292.499 232.585 282.392Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.863,
    d: "M230.672 282.003C231.489 272.198 217.139 262.754 198.621 260.91C180.103 259.066 164.429 265.519 163.613 275.324C162.796 285.129 177.146 294.573 195.664 296.417C214.182 298.261 229.856 291.808 230.672 282.003Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.882,
    d: "M228.739 281.666C229.527 272.164 215.87 263.044 198.235 261.296C180.599 259.547 165.665 265.832 164.877 275.334C164.089 284.835 177.746 293.955 195.382 295.703C213.017 297.452 227.952 291.167 228.739 281.666Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    d: "M226.854 281.327C227.614 272.129 214.648 263.332 197.894 261.679C181.141 260.025 166.944 266.14 166.184 275.338C165.425 284.536 178.391 293.333 195.145 294.986C211.898 296.64 226.095 290.524 226.854 281.327Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.922,
    d: "M224.904 280.972C225.634 272.078 213.359 263.606 197.488 262.05C181.617 260.494 168.16 266.443 167.431 275.337C166.701 284.232 178.976 292.703 194.847 294.259C210.718 295.815 224.175 289.866 224.904 280.972Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.941,
    d: "M223.013 280.63C223.713 272.04 212.128 263.892 197.139 262.433C182.15 260.973 169.431 266.754 168.732 275.344C168.032 283.935 179.616 292.082 194.605 293.542C209.595 295.001 222.313 289.221 223.013 280.63Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.961,
    d: "M221.068 280.305C221.737 272.019 210.845 264.197 196.738 262.834C182.632 261.472 170.654 267.084 169.985 275.37C169.315 283.656 180.208 291.478 194.314 292.841C208.42 294.204 220.398 288.591 221.068 280.305Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M219.147 279.928C219.784 271.944 209.579 264.449 196.353 263.188C183.128 261.926 171.89 267.376 171.253 275.36C170.616 283.343 180.821 290.838 194.047 292.099C207.272 293.361 218.51 287.911 219.147 279.928Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.233 279.583C217.837 271.902 208.32 264.735 195.976 263.574C183.631 262.413 173.135 267.698 172.53 275.378C171.926 283.059 181.444 290.226 193.788 291.387C206.132 292.548 216.629 287.263 217.233 279.583Z",
    fill: "#0F0A26"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M190.646 1.39534L321.45 83.6175C324.081 85.2716 326.266 87.655 327.786 90.5274C329.306 93.3998 330.106 96.6595 330.106 99.978V228.732C330.106 230.182 329.758 231.607 329.095 232.863C328.433 234.119 327.48 235.163 326.332 235.889C325.184 236.616 323.882 236.999 322.556 237.001C321.229 237.003 319.926 236.623 318.777 235.9L186.18 152.55C183.217 150.688 180.755 148.004 179.042 144.769C177.33 141.535 176.427 137.864 176.426 134.126V10.3911C176.426 8.57101 176.863 6.7829 177.695 5.20622C178.526 3.62953 179.722 2.31972 181.163 1.40831C182.604 0.49689 184.239 0.0159055 185.903 0.013619C187.568 0.0113325 189.203 0.487882 190.646 1.39534Z",
    fill: "url(#paint0_linear_6_1917)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.866 4.33819L315.67 86.5604C318.301 88.2145 320.486 90.5979 322.006 93.4703C323.526 96.3427 324.326 99.6025 324.325 102.921V231.675C324.325 233.124 323.977 234.549 323.314 235.805C322.652 237.061 321.699 238.104 320.551 238.83C319.403 239.556 318.101 239.94 316.775 239.942C315.449 239.944 314.146 239.565 312.996 238.843L180.4 155.493C177.437 153.63 174.974 150.947 173.262 147.712C171.549 144.478 170.647 140.807 170.646 137.069V13.3242C170.647 11.5049 171.086 9.71809 171.918 8.14277C172.75 6.56746 173.947 5.25902 175.387 4.34876C176.828 3.43851 178.461 2.9584 180.125 2.95655C181.789 2.95469 183.424 3.43115 184.866 4.33819Z",
    fill: "url(#paint1_linear_6_1917)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M316.759 236.114C316.054 236.111 315.362 235.904 314.753 235.514L182.145 152.159C179.72 150.629 177.705 148.429 176.303 145.779C174.9 143.128 174.16 140.121 174.157 137.059V13.334C174.16 11.5987 174.792 9.93555 175.914 8.70827C177.036 7.48099 178.557 6.78945 180.144 6.78491C181.187 6.78807 182.212 7.09407 183.112 7.6717L313.915 89.894C316.007 91.2132 317.744 93.1104 318.953 95.3956C320.163 97.6807 320.801 100.273 320.805 102.913V231.67C320.806 232.845 320.38 233.973 319.622 234.806C318.864 235.639 317.834 236.109 316.759 236.114Z",
    fill: "url(#paint2_linear_6_1917)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M177.484 160.865L309.836 243.252C310.726 243.801 311.466 244.598 311.98 245.564C312.495 246.529 312.765 247.627 312.762 248.744C312.76 249.861 312.485 250.958 311.966 251.92C311.447 252.883 310.703 253.677 309.811 254.22L217.079 310.372C214.785 311.757 212.202 312.467 209.582 312.434C206.962 312.401 204.394 311.625 202.131 310.182L74.6 229.098C73.4319 228.362 72.4635 227.3 71.7937 226.02C71.124 224.741 70.7769 223.29 70.7878 221.816C70.7988 220.342 71.1675 218.898 71.8563 217.631C72.545 216.364 73.529 215.319 74.7079 214.604L164.119 160.75C166.17 159.517 168.475 158.88 170.816 158.9C173.156 158.92 175.452 159.597 177.484 160.865Z",
    fill: "url(#paint3_linear_6_1917)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M177.484 160.698L309.836 243.085C310.726 243.633 311.466 244.431 311.981 245.396C312.495 246.361 312.765 247.459 312.763 248.576C312.76 249.693 312.485 250.789 311.966 251.751C311.448 252.714 310.704 253.508 309.811 254.051L217.079 310.202C214.785 311.587 212.202 312.297 209.582 312.264C206.962 312.231 204.394 311.455 202.131 310.013L74.6 228.928C73.4319 228.192 72.4635 227.13 71.7937 225.851C71.124 224.572 70.7769 223.121 70.7878 221.647C70.7988 220.173 71.1675 218.728 71.8563 217.461C72.545 216.194 73.529 215.15 74.7079 214.435L164.119 160.583C166.17 159.35 168.475 158.713 170.816 158.733C173.156 158.753 175.452 159.43 177.484 160.698Z",
    fill: "url(#paint4_linear_6_1917)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.484 154.798L309.836 237.185C310.726 237.733 311.466 238.531 311.98 239.497C312.495 240.462 312.765 241.559 312.762 242.677C312.76 243.794 312.485 244.89 311.966 245.853C311.447 246.815 310.703 247.61 309.811 248.153L217.079 304.304C214.785 305.689 212.202 306.4 209.582 306.366C206.962 306.333 204.394 305.558 202.131 304.115L74.6 223.03C73.4319 222.294 72.4635 221.233 71.7937 219.953C71.124 218.674 70.7769 217.223 70.7878 215.749C70.7988 214.275 71.1675 212.831 71.8563 211.564C72.545 210.296 73.529 209.252 74.7079 208.537L164.119 154.685C166.17 153.452 168.475 152.814 170.815 152.834C173.155 152.854 175.451 153.53 177.484 154.798Z",
    fill: "url(#paint5_linear_6_1917)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M309.811 247.731L217.079 303.881C214.785 305.266 212.202 305.977 209.582 305.944C206.962 305.911 204.395 305.135 202.131 303.693L74.6001 222.605C73.4595 221.888 72.5098 220.858 71.8448 219.617C71.1797 218.376 70.8223 216.966 70.808 215.528C70.7541 217.037 71.0791 218.533 71.7475 219.855C72.416 221.177 73.4024 222.273 74.6001 223.025L202.119 304.112C204.383 305.555 206.951 306.331 209.571 306.364C212.191 306.397 214.774 305.686 217.068 304.302L309.8 248.15C310.722 247.596 311.483 246.771 311.999 245.768C312.515 244.766 312.765 243.625 312.72 242.476C312.697 243.553 312.417 244.605 311.906 245.527C311.396 246.449 310.673 247.209 309.811 247.731Z",
    fill: "#FAFAFC"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M168.395 174.526C168.564 174.591 168.711 174.711 168.815 174.871C168.919 175.031 168.974 175.223 168.974 175.419C168.974 175.615 168.919 175.807 168.815 175.967C168.711 176.126 168.564 176.247 168.395 176.312L163.583 179.37C163.148 179.611 162.667 179.737 162.18 179.737C161.692 179.737 161.211 179.611 160.777 179.37L155.933 176.312C155.765 176.248 155.619 176.129 155.516 175.97C155.413 175.812 155.357 175.622 155.357 175.428C155.357 175.233 155.413 175.043 155.516 174.885C155.619 174.726 155.765 174.607 155.933 174.543L160.745 171.485C161.18 171.244 161.661 171.119 162.148 171.119C162.636 171.119 163.116 171.244 163.551 171.485L168.395 174.526Z",
    fill: "url(#paint6_linear_6_1917)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M178.019 168.409C178.188 168.474 178.335 168.595 178.439 168.755C178.543 168.915 178.599 169.106 178.599 169.302C178.599 169.499 178.543 169.69 178.439 169.85C178.335 170.01 178.188 170.131 178.019 170.195L173.22 173.244C172.784 173.487 172.301 173.614 171.811 173.614C171.321 173.614 170.837 173.487 170.401 173.244L165.557 170.185C165.387 170.123 165.239 170.003 165.134 169.844C165.03 169.684 164.973 169.493 164.973 169.296C164.973 169.1 165.03 168.908 165.134 168.749C165.239 168.589 165.387 168.47 165.557 168.407L170.358 165.356C170.793 165.115 171.274 164.989 171.761 164.989C172.249 164.989 172.729 165.115 173.164 165.356L178.019 168.409Z",
    fill: "url(#paint7_linear_6_1917)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M259.432 219.81C259.602 219.874 259.749 219.995 259.852 220.155C259.956 220.315 260.012 220.506 260.012 220.703C260.012 220.899 259.956 221.09 259.852 221.25C259.749 221.41 259.602 221.531 259.432 221.596L254.634 224.644C254.197 224.887 253.713 225.014 253.223 225.014C252.733 225.014 252.249 224.887 251.812 224.644L246.982 221.596C246.193 221.104 246.191 220.306 246.982 219.81L251.783 216.761C252.22 216.518 252.702 216.391 253.192 216.391C253.682 216.391 254.166 216.518 254.602 216.761L259.432 219.81Z",
    fill: "url(#paint8_linear_6_1917)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M239.627 219.498C239.798 219.561 239.946 219.681 240.05 219.842C240.155 220.002 240.212 220.194 240.212 220.391C240.212 220.588 240.155 220.78 240.05 220.94C239.946 221.1 239.798 221.22 239.627 221.284L234.815 224.342C234.38 224.585 233.899 224.712 233.411 224.712C232.923 224.712 232.442 224.585 232.007 224.342L227.177 221.293C226.389 220.802 226.386 220.004 227.155 219.515L231.967 216.456C232.403 216.214 232.886 216.087 233.376 216.087C233.866 216.087 234.349 216.214 234.786 216.456L239.627 219.498Z",
    fill: "url(#paint9_linear_6_1917)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M249.251 213.381C249.422 213.444 249.57 213.564 249.675 213.725C249.779 213.885 249.836 214.077 249.836 214.274C249.836 214.471 249.779 214.663 249.675 214.823C249.57 214.983 249.422 215.103 249.251 215.167L244.453 218.218C244.017 218.463 243.533 218.591 243.043 218.591C242.553 218.591 242.069 218.463 241.633 218.218L236.803 215.167C236.015 214.675 236.012 213.877 236.803 213.381L241.602 210.332C242.038 210.089 242.522 209.963 243.012 209.963C243.502 209.963 243.984 210.089 244.421 210.332L249.251 213.381Z",
    fill: "url(#paint10_linear_6_1917)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M229.457 213.079C229.626 213.143 229.773 213.263 229.877 213.422C229.981 213.582 230.036 213.772 230.036 213.968C230.036 214.164 229.981 214.355 229.877 214.514C229.773 214.673 229.626 214.793 229.457 214.857L224.645 217.916C224.212 218.157 223.734 218.282 223.248 218.282C222.762 218.282 222.283 218.157 221.85 217.916L217.007 214.857C216.232 214.366 216.214 213.568 216.985 213.079L221.797 210.02C222.234 209.779 222.716 209.654 223.206 209.654C223.696 209.654 224.179 209.779 224.616 210.02L229.457 213.079Z",
    fill: "url(#paint11_linear_6_1917)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M239.084 206.962C239.253 207.026 239.4 207.146 239.504 207.306C239.607 207.465 239.663 207.656 239.663 207.851C239.663 208.047 239.607 208.238 239.504 208.397C239.4 208.557 239.253 208.677 239.084 208.741L234.285 211.792C233.851 212.034 233.37 212.161 232.882 212.161C232.394 212.161 231.914 212.034 231.479 211.792L226.636 208.733C226.465 208.67 226.317 208.549 226.212 208.389C226.107 208.229 226.051 208.037 226.051 207.84C226.051 207.643 226.107 207.451 226.212 207.291C226.317 207.131 226.465 207.011 226.636 206.947L231.434 203.899C231.872 203.659 232.355 203.534 232.844 203.534C233.333 203.534 233.816 203.659 234.254 203.899L239.084 206.962Z",
    fill: "url(#paint12_linear_6_1917)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M189.285 199.927C189.456 199.99 189.604 200.11 189.709 200.27C189.813 200.43 189.869 200.622 189.869 200.819C189.869 201.016 189.813 201.208 189.709 201.368C189.604 201.529 189.456 201.649 189.285 201.712L184.487 204.761C184.049 205.002 183.566 205.128 183.077 205.128C182.587 205.128 182.104 205.002 181.667 204.761L176.824 201.702C176.654 201.638 176.507 201.517 176.403 201.357C176.299 201.197 176.244 201.006 176.244 200.81C176.244 200.614 176.299 200.422 176.403 200.262C176.507 200.102 176.654 199.981 176.824 199.917L181.622 196.868C182.059 196.625 182.542 196.499 183.032 196.499C183.522 196.499 184.005 196.625 184.442 196.868L189.285 199.927Z",
    fill: "url(#paint13_linear_6_1917)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M199.453 206.348C200.239 206.839 200.243 207.637 199.453 208.134L194.654 211.182C194.217 211.425 193.734 211.552 193.244 211.552C192.754 211.552 192.271 211.425 191.835 211.182L187.005 208.134C186.835 208.069 186.688 207.948 186.584 207.788C186.481 207.628 186.425 207.437 186.425 207.241C186.425 207.045 186.481 206.853 186.584 206.693C186.688 206.533 186.835 206.413 187.005 206.348L191.803 203.297C192.24 203.054 192.723 202.928 193.213 202.928C193.703 202.928 194.186 203.054 194.622 203.297L199.453 206.348Z",
    fill: "url(#paint14_linear_6_1917)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M209.092 200.224C209.263 200.287 209.411 200.407 209.516 200.568C209.621 200.728 209.677 200.92 209.677 201.117C209.677 201.314 209.621 201.506 209.516 201.666C209.411 201.826 209.263 201.946 209.092 202.01L204.28 205.068C203.846 205.311 203.365 205.437 202.877 205.437C202.39 205.437 201.909 205.311 201.475 205.068L196.644 202.017C195.872 201.526 195.854 200.727 196.622 200.239L201.434 197.18C201.871 196.94 202.354 196.815 202.844 196.815C203.333 196.815 203.816 196.94 204.253 197.18L209.092 200.224Z",
    fill: "url(#paint15_linear_6_1917)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M230.542 238.17C230.713 238.233 230.861 238.353 230.966 238.514C231.07 238.674 231.127 238.866 231.127 239.063C231.127 239.26 231.07 239.452 230.966 239.612C230.861 239.772 230.713 239.892 230.542 239.956L225.744 243.007C225.306 243.246 224.824 243.371 224.334 243.371C223.845 243.371 223.362 243.246 222.924 243.007L218.094 239.956C217.924 239.892 217.776 239.772 217.671 239.612C217.566 239.452 217.51 239.26 217.51 239.063C217.51 238.866 217.566 238.674 217.671 238.514C217.776 238.353 217.924 238.233 218.094 238.17L222.893 235.121C223.329 234.876 223.812 234.748 224.303 234.748C224.793 234.748 225.276 234.876 225.712 235.121L230.542 238.17Z",
    fill: "url(#paint16_linear_6_1917)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M240.166 232.051C240.337 232.114 240.485 232.234 240.59 232.394C240.694 232.554 240.751 232.746 240.751 232.943C240.751 233.14 240.694 233.332 240.59 233.492C240.485 233.653 240.337 233.773 240.166 233.836L235.365 236.885C234.928 237.125 234.445 237.25 233.956 237.25C233.466 237.25 232.984 237.125 232.546 236.885L227.716 233.836C227.546 233.773 227.397 233.653 227.293 233.492C227.188 233.332 227.131 233.14 227.131 232.943C227.131 232.746 227.188 232.554 227.293 232.394C227.397 232.234 227.546 232.114 227.716 232.051L232.515 228.999C232.951 228.754 233.434 228.627 233.924 228.627C234.415 228.627 234.898 228.754 235.334 228.999L240.166 232.051Z",
    fill: "url(#paint17_linear_6_1917)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M210.195 225.322C210.365 225.385 210.512 225.505 210.616 225.664C210.72 225.823 210.776 226.014 210.776 226.21C210.776 226.406 210.72 226.597 210.616 226.756C210.512 226.915 210.365 227.035 210.195 227.098L205.397 230.149C204.962 230.39 204.481 230.515 203.994 230.515C203.506 230.515 203.026 230.39 202.591 230.149L197.747 227.091C197.578 227.026 197.431 226.905 197.327 226.745C197.223 226.585 197.167 226.394 197.167 226.198C197.167 226.002 197.223 225.81 197.327 225.65C197.431 225.49 197.578 225.37 197.747 225.305L202.546 222.256C202.983 222.014 203.466 221.887 203.956 221.887C204.446 221.887 204.928 222.014 205.365 222.256L210.195 225.322Z",
    fill: "url(#paint18_linear_6_1917)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M220.368 231.738C221.154 232.23 221.159 233.028 220.368 233.524L215.567 236.573C215.13 236.816 214.647 236.942 214.157 236.942C213.667 236.942 213.184 236.816 212.748 236.573L207.918 233.524C207.747 233.461 207.599 233.341 207.494 233.18C207.389 233.02 207.333 232.828 207.333 232.631C207.333 232.434 207.389 232.243 207.494 232.082C207.599 231.922 207.747 231.802 207.918 231.738L212.716 228.688C213.152 228.443 213.635 228.315 214.126 228.315C214.616 228.315 215.099 228.443 215.536 228.688L220.368 231.738Z",
    fill: "url(#paint19_linear_6_1917)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M229.985 225.622C230.772 226.113 230.776 226.911 229.985 227.408L225.187 230.459C224.75 230.701 224.267 230.828 223.777 230.828C223.287 230.828 222.804 230.701 222.367 230.459L217.537 227.408C217.367 227.344 217.219 227.224 217.114 227.064C217.009 226.904 216.953 226.712 216.953 226.515C216.953 226.318 217.009 226.126 217.114 225.966C217.219 225.806 217.367 225.685 217.537 225.622L222.338 222.573C222.774 222.328 223.258 222.2 223.748 222.2C224.238 222.2 224.721 222.328 225.157 222.573L229.985 225.622Z",
    fill: "url(#paint20_linear_6_1917)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M219.82 219.203C219.99 219.266 220.138 219.385 220.242 219.545C220.347 219.704 220.404 219.896 220.404 220.092C220.404 220.289 220.347 220.48 220.242 220.64C220.138 220.799 219.99 220.919 219.82 220.981L215.021 224.033C214.586 224.273 214.105 224.399 213.618 224.399C213.131 224.399 212.65 224.273 212.215 224.033L207.372 220.974C207.202 220.909 207.055 220.789 206.951 220.629C206.847 220.469 206.792 220.277 206.792 220.081C206.792 219.885 206.847 219.694 206.951 219.534C207.055 219.374 207.202 219.253 207.372 219.188L212.172 216.137C212.609 215.894 213.092 215.768 213.582 215.768C214.072 215.768 214.555 215.894 214.992 216.137L219.82 219.203Z",
    fill: "url(#paint21_linear_6_1917)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M189.82 212.462C190.606 212.953 190.611 213.752 189.82 214.248L185.019 217.299C184.582 217.542 184.099 217.668 183.609 217.668C183.119 217.668 182.636 217.542 182.2 217.299L177.37 214.248C177.2 214.183 177.053 214.063 176.949 213.903C176.845 213.743 176.79 213.551 176.79 213.355C176.79 213.159 176.845 212.968 176.949 212.808C177.053 212.648 177.2 212.527 177.37 212.462L182.182 209.404C182.618 209.161 183.101 209.034 183.591 209.034C184.081 209.034 184.564 209.161 185.001 209.404L189.82 212.462Z",
    fill: "url(#paint22_linear_6_1917)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M200.012 218.891C200.183 218.954 200.331 219.075 200.436 219.235C200.54 219.395 200.597 219.587 200.597 219.784C200.597 219.981 200.54 220.173 200.436 220.333C200.331 220.493 200.183 220.613 200.012 220.677L195.214 223.728C194.776 223.969 194.294 224.094 193.804 224.094C193.314 224.094 192.831 223.969 192.394 223.728L187.562 220.677C187.391 220.613 187.244 220.493 187.139 220.333C187.034 220.173 186.978 219.981 186.978 219.784C186.978 219.587 187.034 219.395 187.139 219.235C187.244 219.075 187.391 218.954 187.562 218.891L192.361 215.84C192.797 215.595 193.28 215.467 193.77 215.467C194.261 215.467 194.744 215.595 195.18 215.84L200.012 218.891Z",
    fill: "url(#paint23_linear_6_1917)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M220.918 244.281C221.089 244.345 221.237 244.465 221.341 244.625C221.446 244.786 221.503 244.978 221.503 245.174C221.503 245.371 221.446 245.563 221.341 245.724C221.237 245.884 221.089 246.004 220.918 246.067L216.12 249.116C215.683 249.359 215.2 249.485 214.71 249.485C214.22 249.485 213.737 249.359 213.3 249.116L208.47 246.067C207.684 245.576 207.68 244.778 208.47 244.281L213.269 241.231C213.705 240.986 214.188 240.858 214.678 240.858C215.169 240.858 215.652 240.986 216.088 241.231L220.918 244.281Z",
    fill: "url(#paint24_linear_6_1917)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M210.739 237.855C211.525 238.347 211.53 239.145 210.739 239.641L205.941 242.69C205.504 242.935 205.021 243.063 204.531 243.063C204.04 243.063 203.557 242.935 203.121 242.69L199.302 240.272L198.302 239.641L192.965 236.271L188.121 233.212L182.783 229.842L177.953 226.793L167.772 220.365C167.602 220.301 167.454 220.181 167.349 220.021C167.244 219.861 167.188 219.669 167.188 219.472C167.188 219.275 167.244 219.083 167.349 218.923C167.454 218.763 167.602 218.642 167.772 218.579L172.571 215.528C173.007 215.285 173.49 215.158 173.98 215.158C174.47 215.158 174.953 215.285 175.39 215.528L185.571 221.957L190.401 225.005L195.739 228.376L200.583 231.434L205.92 234.804L206.92 235.436L210.739 237.855Z",
    fill: "url(#paint25_linear_6_1917)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M209.636 212.774C209.806 212.838 209.955 212.958 210.059 213.118C210.164 213.278 210.221 213.47 210.221 213.667C210.221 213.864 210.164 214.056 210.059 214.216C209.955 214.376 209.806 214.497 209.636 214.56L204.837 217.611C204.4 217.851 203.917 217.976 203.428 217.976C202.938 217.976 202.456 217.851 202.018 217.611L197.188 214.56C197.017 214.497 196.869 214.376 196.764 214.216C196.66 214.056 196.604 213.864 196.604 213.667C196.604 213.47 196.66 213.278 196.764 213.118C196.869 212.958 197.017 212.838 197.188 212.774L201.986 209.726C202.423 209.481 202.906 209.353 203.396 209.353C203.887 209.353 204.37 209.481 204.806 209.726L209.636 212.774Z",
    fill: "url(#paint26_linear_6_1917)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M219.274 206.65C219.443 206.715 219.59 206.835 219.694 206.995C219.798 207.155 219.854 207.347 219.854 207.543C219.854 207.739 219.798 207.931 219.694 208.091C219.59 208.251 219.443 208.371 219.274 208.436L214.462 211.494C214.027 211.735 213.546 211.861 213.058 211.861C212.57 211.861 212.089 211.735 211.654 211.494L206.824 208.446C206.037 207.955 206.033 207.156 206.801 206.667L211.613 203.609C212.05 203.366 212.533 203.239 213.023 203.239C213.513 203.239 213.996 203.366 214.433 203.609L219.274 206.65Z",
    fill: "url(#paint27_linear_6_1917)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M228.897 200.536C229.067 200.6 229.214 200.721 229.318 200.881C229.422 201.041 229.477 201.232 229.477 201.429C229.477 201.625 229.422 201.816 229.318 201.976C229.214 202.136 229.067 202.257 228.897 202.322L224.097 205.373C223.66 205.615 223.177 205.742 222.687 205.742C222.197 205.742 221.714 205.615 221.277 205.373L216.447 202.322C215.659 201.83 215.656 201.032 216.447 200.536L221.246 197.485C221.683 197.242 222.166 197.115 222.656 197.115C223.146 197.115 223.628 197.242 224.065 197.485L228.897 200.536Z",
    fill: "url(#paint28_linear_6_1917)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M218.719 194.107C218.889 194.17 219.038 194.291 219.142 194.451C219.247 194.611 219.304 194.803 219.304 195C219.304 195.197 219.247 195.389 219.142 195.549C219.038 195.709 218.889 195.829 218.719 195.893L213.92 198.944C213.484 199.189 213.001 199.317 212.511 199.317C212.021 199.317 211.537 199.189 211.101 198.944L206.271 195.893C206.101 195.829 205.953 195.709 205.848 195.549C205.743 195.389 205.687 195.197 205.687 195C205.687 194.803 205.743 194.611 205.848 194.451C205.953 194.291 206.101 194.17 206.271 194.107L211.07 191.058C211.507 190.817 211.99 190.692 212.479 190.692C212.969 190.692 213.452 190.817 213.889 191.058L218.719 194.107Z",
    fill: "url(#paint29_linear_6_1917)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M198.924 193.803C199.094 193.867 199.241 193.988 199.345 194.148C199.449 194.308 199.504 194.499 199.504 194.695C199.504 194.891 199.449 195.083 199.345 195.243C199.241 195.403 199.094 195.524 198.924 195.588L194.112 198.647C193.678 198.887 193.197 199.013 192.709 199.013C192.222 199.013 191.741 198.887 191.307 198.647L186.463 195.588C185.688 195.097 185.672 194.299 186.441 193.81L191.253 190.751C191.69 190.511 192.173 190.387 192.662 190.387C193.152 190.387 193.635 190.511 194.072 190.751L198.924 193.803Z",
    fill: "url(#paint30_linear_6_1917)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M208.551 187.686C208.72 187.75 208.867 187.871 208.971 188.031C209.075 188.191 209.131 188.382 209.131 188.579C209.131 188.775 209.075 188.966 208.971 189.126C208.867 189.286 208.72 189.407 208.551 189.472L203.752 192.522C203.316 192.765 202.833 192.892 202.343 192.892C201.853 192.892 201.37 192.765 200.933 192.522L196.09 189.464C195.919 189.401 195.771 189.281 195.666 189.12C195.561 188.96 195.505 188.768 195.505 188.571C195.505 188.374 195.561 188.182 195.666 188.022C195.771 187.862 195.919 187.742 196.09 187.678L200.888 184.627C201.326 184.387 201.808 184.263 202.298 184.263C202.787 184.263 203.27 184.387 203.707 184.627L208.551 187.686Z",
    fill: "url(#paint31_linear_6_1917)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M139.504 192.884C139.675 192.947 139.823 193.068 139.927 193.228C140.032 193.388 140.089 193.58 140.089 193.777C140.089 193.974 140.032 194.166 139.927 194.326C139.823 194.486 139.675 194.606 139.504 194.669L134.706 197.721C134.269 197.964 133.786 198.09 133.296 198.09C132.806 198.09 132.323 197.964 131.886 197.721L127.043 194.662C126.872 194.6 126.725 194.48 126.62 194.32C126.515 194.161 126.458 193.969 126.458 193.773C126.458 193.576 126.515 193.385 126.62 193.226C126.725 193.066 126.872 192.946 127.043 192.884L131.841 189.833C132.276 189.59 132.756 189.464 133.244 189.464C133.732 189.464 134.213 189.59 134.647 189.833L139.504 192.884Z",
    fill: "url(#paint32_linear_6_1917)"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M159.299 193.188C160.085 193.679 160.089 194.478 159.299 194.974L154.5 198.023C154.063 198.266 153.58 198.392 153.09 198.392C152.6 198.392 152.117 198.266 151.68 198.023L146.851 194.974C146.681 194.91 146.534 194.789 146.43 194.629C146.326 194.469 146.271 194.277 146.271 194.081C146.271 193.885 146.326 193.694 146.43 193.534C146.534 193.374 146.681 193.253 146.851 193.188L151.649 190.14C152.086 189.897 152.569 189.77 153.059 189.77C153.549 189.77 154.032 189.897 154.468 190.14L159.299 193.188Z",
    fill: "url(#paint33_linear_6_1917)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M149.67 199.305C150.458 199.796 150.46 200.595 149.67 201.091L144.871 204.142C144.435 204.387 143.952 204.514 143.462 204.514C142.971 204.514 142.488 204.387 142.052 204.142L137.222 201.091C137.051 201.027 136.903 200.907 136.798 200.747C136.694 200.587 136.637 200.395 136.637 200.198C136.637 200.001 136.694 199.809 136.798 199.649C136.903 199.489 137.051 199.369 137.222 199.305L142.02 196.254C142.457 196.011 142.94 195.885 143.43 195.885C143.92 195.885 144.403 196.011 144.84 196.254L149.67 199.305Z",
    fill: "url(#paint34_linear_6_1917)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M169.478 199.614C169.648 199.678 169.796 199.798 169.901 199.958C170.005 200.119 170.062 200.311 170.062 200.507C170.062 200.704 170.005 200.896 169.901 201.057C169.796 201.217 169.648 201.337 169.478 201.401L164.679 204.451C164.241 204.691 163.759 204.816 163.269 204.816C162.78 204.816 162.297 204.691 161.86 204.451L157.029 201.401C156.859 201.337 156.711 201.217 156.606 201.057C156.501 200.896 156.445 200.704 156.445 200.507C156.445 200.311 156.501 200.119 156.606 199.958C156.711 199.798 156.859 199.678 157.029 199.614L161.83 196.566C162.266 196.321 162.75 196.193 163.24 196.193C163.73 196.193 164.214 196.321 164.65 196.566L169.478 199.614Z",
    fill: "url(#paint35_linear_6_1917)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M159.853 205.731C160.024 205.795 160.172 205.915 160.277 206.075C160.381 206.235 160.438 206.427 160.438 206.624C160.438 206.821 160.381 207.013 160.277 207.173C160.172 207.333 160.024 207.454 159.853 207.517L155.055 210.568C154.618 210.811 154.135 210.937 153.645 210.937C153.155 210.937 152.672 210.811 152.235 210.568L147.405 207.517C146.617 207.026 146.614 206.228 147.405 205.731L152.204 202.68C152.64 202.435 153.123 202.308 153.613 202.308C154.104 202.308 154.587 202.435 155.023 202.68L159.853 205.731Z",
    fill: "url(#paint36_linear_6_1917)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M179.658 206.043C179.829 206.107 179.977 206.227 180.082 206.387C180.187 206.547 180.243 206.739 180.243 206.936C180.243 207.133 180.187 207.325 180.082 207.485C179.977 207.646 179.829 207.766 179.658 207.829L174.86 210.88C174.423 211.121 173.94 211.247 173.45 211.247C172.961 211.247 172.478 211.121 172.04 210.88L167.197 207.822C167.027 207.757 166.881 207.636 166.777 207.476C166.673 207.316 166.617 207.125 166.617 206.929C166.617 206.733 166.673 206.541 166.777 206.381C166.881 206.221 167.027 206.1 167.197 206.036L171.998 202.985C172.435 202.742 172.918 202.615 173.407 202.615C173.897 202.615 174.38 202.742 174.817 202.985L179.658 206.043Z",
    fill: "url(#paint37_linear_6_1917)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M170.037 212.16C170.207 212.223 170.355 212.344 170.46 212.504C170.565 212.664 170.621 212.856 170.621 213.053C170.621 213.25 170.565 213.442 170.46 213.602C170.355 213.762 170.207 213.882 170.037 213.946L165.238 216.997C164.801 217.24 164.318 217.366 163.828 217.366C163.339 217.366 162.855 217.24 162.419 216.997L157.575 213.938C157.405 213.875 157.257 213.755 157.152 213.595C157.047 213.435 156.991 213.243 156.991 213.046C156.991 212.849 157.047 212.657 157.152 212.496C157.257 212.336 157.405 212.216 157.575 212.153L162.374 209.102C162.81 208.859 163.294 208.732 163.783 208.732C164.273 208.732 164.756 208.859 165.193 209.102L170.037 212.16Z",
    fill: "url(#paint38_linear_6_1917)"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M179.106 193.498C179.276 193.561 179.424 193.682 179.529 193.842C179.634 194.002 179.69 194.194 179.69 194.391C179.69 194.588 179.634 194.78 179.529 194.94C179.424 195.1 179.276 195.22 179.106 195.284L174.307 198.332C173.87 198.573 173.387 198.699 172.898 198.699C172.408 198.699 171.925 198.573 171.488 198.332L166.658 195.284C166.487 195.22 166.339 195.1 166.234 194.94C166.13 194.78 166.073 194.588 166.073 194.391C166.073 194.194 166.13 194.002 166.234 193.842C166.339 193.682 166.487 193.561 166.658 193.498L171.456 190.447C171.893 190.202 172.376 190.074 172.866 190.074C173.356 190.074 173.839 190.202 174.276 190.447L179.106 193.498Z",
    fill: "url(#paint39_linear_6_1917)"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M188.75 187.374C188.919 187.438 189.066 187.559 189.17 187.719C189.274 187.879 189.33 188.071 189.33 188.267C189.33 188.463 189.274 188.654 189.17 188.814C189.066 188.974 188.919 189.095 188.75 189.159L183.936 192.218C183.501 192.459 183.02 192.585 182.533 192.585C182.045 192.585 181.565 192.459 181.13 192.218L176.3 189.169C175.514 188.678 175.509 187.88 176.277 187.391L181.089 184.333C181.526 184.089 182.009 183.963 182.499 183.963C182.989 183.963 183.472 184.089 183.909 184.333L188.75 187.374Z",
    fill: "url(#paint40_linear_6_1917)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M198.368 181.257C198.537 181.322 198.684 181.442 198.788 181.602C198.892 181.762 198.947 181.954 198.947 182.15C198.947 182.346 198.892 182.538 198.788 182.698C198.684 182.858 198.537 182.978 198.368 183.043L193.569 186.094C193.132 186.337 192.649 186.463 192.159 186.463C191.669 186.463 191.186 186.337 190.75 186.094L185.92 183.043C185.133 182.551 185.129 181.753 185.92 181.257L190.718 178.208C191.155 177.965 191.638 177.839 192.128 177.839C192.618 177.839 193.101 177.965 193.537 178.208L198.368 181.257Z",
    fill: "url(#paint41_linear_6_1917)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M168.92 187.072C169.706 187.563 169.711 188.361 168.92 188.858L164.122 191.908C163.685 192.151 163.202 192.278 162.712 192.278C162.222 192.278 161.739 192.151 161.302 191.908L156.472 188.858C156.303 188.793 156.156 188.672 156.052 188.512C155.948 188.352 155.892 188.161 155.892 187.965C155.892 187.768 155.948 187.577 156.052 187.417C156.156 187.257 156.303 187.136 156.472 187.072L161.271 184.023C161.707 183.78 162.19 183.653 162.68 183.653C163.17 183.653 163.653 183.78 164.09 184.023L168.92 187.072Z",
    fill: "url(#paint42_linear_6_1917)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M178.562 180.947C178.733 181.011 178.881 181.131 178.986 181.291C179.091 181.451 179.147 181.643 179.147 181.84C179.147 182.037 179.091 182.229 178.986 182.389C178.881 182.55 178.733 182.67 178.562 182.733L173.75 185.792C173.315 186.035 172.834 186.162 172.346 186.162C171.858 186.162 171.376 186.035 170.942 185.792L166.112 182.743C165.337 182.252 165.321 181.454 166.09 180.965L170.902 177.906C171.339 177.666 171.822 177.542 172.311 177.542C172.801 177.542 173.283 177.666 173.721 177.906L178.562 180.947Z",
    fill: "url(#paint43_linear_6_1917)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M188.184 174.828C188.355 174.892 188.503 175.012 188.608 175.172C188.713 175.332 188.769 175.524 188.769 175.721C188.769 175.918 188.713 176.11 188.608 176.27C188.503 176.43 188.355 176.551 188.184 176.614L183.386 179.663C182.95 179.908 182.466 180.035 181.976 180.035C181.486 180.035 181.002 179.908 180.566 179.663L175.736 176.614C175.566 176.551 175.418 176.43 175.313 176.27C175.208 176.11 175.152 175.918 175.152 175.721C175.152 175.524 175.208 175.332 175.313 175.172C175.418 175.012 175.566 174.892 175.736 174.828L180.535 171.777C180.972 171.537 181.455 171.412 181.945 171.412C182.434 171.412 182.917 171.537 183.354 171.777L188.184 174.828Z",
    fill: "url(#paint44_linear_6_1917)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M249.809 225.926C249.978 225.991 250.125 226.112 250.229 226.272C250.333 226.432 250.389 226.623 250.389 226.819C250.389 227.015 250.333 227.207 250.229 227.367C250.125 227.527 249.978 227.648 249.809 227.712L244.997 230.771C244.561 231.012 244.08 231.137 243.593 231.137C243.105 231.137 242.624 231.012 242.188 230.771L237.358 227.722C236.572 227.231 236.568 226.432 237.336 225.944L242.148 222.885C242.585 222.642 243.068 222.516 243.558 222.516C244.048 222.516 244.531 222.642 244.967 222.885L249.809 225.926Z",
    fill: "url(#paint45_linear_6_1917)"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M259.976 232.345C260.147 232.409 260.295 232.529 260.4 232.689C260.504 232.849 260.561 233.041 260.561 233.238C260.561 233.435 260.504 233.627 260.4 233.787C260.295 233.948 260.147 234.068 259.976 234.131L255.164 237.189C254.73 237.432 254.249 237.559 253.761 237.559C253.273 237.559 252.792 237.432 252.358 237.189L247.528 234.139C246.755 233.647 246.735 232.849 247.506 232.36L252.318 229.302C252.755 229.062 253.238 228.937 253.727 228.937C254.217 228.937 254.7 229.062 255.137 229.302L259.976 232.345Z",
    fill: "url(#paint46_linear_6_1917)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M231.086 250.7C231.872 251.192 231.877 251.99 231.086 252.486L226.287 255.535C225.851 255.78 225.368 255.908 224.878 255.908C224.387 255.908 223.904 255.78 223.468 255.535L218.638 252.486C218.467 252.423 218.319 252.303 218.214 252.142C218.11 251.982 218.053 251.79 218.053 251.593C218.053 251.396 218.11 251.204 218.214 251.044C218.319 250.884 218.467 250.764 218.638 250.7L223.436 247.649C223.873 247.407 224.356 247.28 224.846 247.28C225.336 247.28 225.819 247.407 226.256 247.649L231.086 250.7Z",
    fill: "url(#paint47_linear_6_1917)"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M241.269 257.129C242.056 257.62 242.06 258.419 241.269 258.915L236.471 261.966C236.034 262.211 235.551 262.338 235.061 262.338C234.571 262.338 234.088 262.211 233.651 261.966L228.821 258.915C228.033 258.424 228.03 257.625 228.821 257.129L233.622 254.081C234.058 253.836 234.541 253.707 235.032 253.707C235.522 253.707 236.006 253.836 236.442 254.081L241.269 257.129Z",
    fill: "url(#paint48_linear_6_1917)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M250.893 251.015C251.682 251.506 251.684 252.304 250.893 252.801L246.095 255.852C245.658 256.095 245.175 256.221 244.685 256.221C244.195 256.221 243.712 256.095 243.275 255.852L238.445 252.801C238.275 252.737 238.127 252.617 238.022 252.457C237.917 252.297 237.861 252.105 237.861 251.908C237.861 251.711 237.917 251.519 238.022 251.359C238.127 251.198 238.275 251.078 238.445 251.015L243.244 247.966C243.68 247.721 244.163 247.594 244.654 247.594C245.144 247.594 245.627 247.721 246.063 247.966L250.893 251.015Z",
    fill: "url(#paint49_linear_6_1917)"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M251.45 263.558C251.621 263.621 251.769 263.741 251.874 263.902C251.979 264.062 252.035 264.254 252.035 264.451C252.035 264.648 251.979 264.84 251.874 265C251.769 265.16 251.621 265.28 251.45 265.344L246.652 268.395C246.215 268.638 245.732 268.764 245.242 268.764C244.752 268.764 244.269 268.638 243.832 268.395L238.989 265.336C238.818 265.273 238.67 265.153 238.566 264.993C238.461 264.832 238.404 264.64 238.404 264.443C238.404 264.247 238.461 264.055 238.566 263.894C238.67 263.734 238.818 263.614 238.989 263.55L243.788 260.5C244.224 260.257 244.707 260.13 245.197 260.13C245.687 260.13 246.17 260.257 246.607 260.5L251.45 263.558Z",
    fill: "url(#paint50_linear_6_1917)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M261.075 257.441C261.245 257.504 261.393 257.625 261.498 257.785C261.603 257.945 261.659 258.137 261.659 258.334C261.659 258.531 261.603 258.723 261.498 258.883C261.393 259.043 261.245 259.163 261.075 259.227L256.276 262.275C255.839 262.515 255.356 262.64 254.866 262.64C254.377 262.64 253.894 262.515 253.457 262.275L248.613 259.217C248.444 259.152 248.297 259.032 248.193 258.872C248.089 258.712 248.033 258.52 248.033 258.324C248.033 258.128 248.089 257.936 248.193 257.776C248.297 257.616 248.444 257.496 248.613 257.431L253.412 254.383C253.848 254.139 254.331 254.013 254.821 254.013C255.311 254.013 255.794 254.139 256.231 254.383L261.075 257.441Z",
    fill: "url(#paint51_linear_6_1917)"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M270.16 238.781C270.33 238.845 270.478 238.965 270.583 239.125C270.688 239.285 270.744 239.477 270.744 239.674C270.744 239.871 270.688 240.063 270.583 240.223C270.478 240.384 270.33 240.504 270.16 240.567L265.348 243.625C264.913 243.868 264.433 243.995 263.945 243.995C263.457 243.995 262.976 243.868 262.542 243.625L257.712 240.575C256.926 240.083 256.921 239.285 257.689 238.796L262.501 235.738C262.938 235.495 263.421 235.368 263.911 235.368C264.401 235.368 264.884 235.495 265.321 235.738L270.16 238.781Z",
    fill: "url(#paint52_linear_6_1917)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M280.339 245.203C280.508 245.267 280.655 245.388 280.759 245.548C280.863 245.708 280.919 245.899 280.919 246.096C280.919 246.292 280.863 246.483 280.759 246.643C280.655 246.803 280.508 246.924 280.339 246.989L275.527 250.047C275.092 250.288 274.611 250.413 274.124 250.413C273.636 250.413 273.156 250.288 272.721 250.047L267.877 246.989C267.102 246.497 267.086 245.699 267.855 245.21L272.667 242.152C273.105 241.912 273.587 241.787 274.077 241.787C274.566 241.787 275.049 241.912 275.486 242.152L280.339 245.203Z",
    fill: "url(#paint53_linear_6_1917)"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M270.701 251.327C270.872 251.39 271.019 251.51 271.124 251.67C271.229 251.831 271.286 252.023 271.286 252.22C271.286 252.417 271.229 252.609 271.124 252.769C271.019 252.929 270.872 253.049 270.701 253.113L265.903 256.164C265.465 256.404 264.982 256.528 264.493 256.528C264.003 256.528 263.521 256.404 263.083 256.164L252.902 249.735L251.195 248.656L248.072 246.691C247.901 246.628 247.753 246.508 247.649 246.348C247.544 246.187 247.487 245.995 247.487 245.798C247.487 245.602 247.544 245.41 247.649 245.249C247.753 245.089 247.901 244.969 248.072 244.905L252.871 241.857C253.307 241.612 253.79 241.484 254.28 241.484C254.77 241.484 255.254 241.612 255.69 241.857L258.813 243.822L260.52 244.9L270.701 251.327Z",
    fill: "url(#paint54_linear_6_1917)"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M289.963 239.086C290.132 239.151 290.279 239.271 290.383 239.431C290.487 239.591 290.543 239.783 290.543 239.979C290.543 240.175 290.487 240.367 290.383 240.527C290.279 240.687 290.132 240.807 289.963 240.872L285.164 243.923C284.728 244.166 284.244 244.292 283.754 244.292C283.264 244.292 282.781 244.166 282.345 243.923L277.501 240.865C277.331 240.801 277.183 240.681 277.078 240.521C276.973 240.36 276.917 240.168 276.917 239.972C276.917 239.775 276.973 239.583 277.078 239.423C277.183 239.262 277.331 239.142 277.501 239.079L282.302 236.03C282.74 235.79 283.223 235.665 283.713 235.665C284.203 235.665 284.686 235.79 285.124 236.03L289.963 239.086Z",
    fill: "url(#paint55_linear_6_1917)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M279.784 232.657C279.954 232.721 280.102 232.841 280.207 233.001C280.312 233.161 280.368 233.353 280.368 233.55C280.368 233.747 280.312 233.939 280.207 234.099C280.102 234.259 279.954 234.38 279.784 234.443L274.985 237.494C274.549 237.739 274.065 237.867 273.574 237.867C273.084 237.867 272.6 237.739 272.163 237.494L267.333 234.443C266.545 233.952 266.543 233.156 267.333 232.657L272.132 229.606C272.569 229.363 273.052 229.237 273.542 229.237C274.032 229.237 274.514 229.363 274.951 229.606L279.784 232.657Z",
    fill: "url(#paint56_linear_6_1917)"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M269.603 226.233C269.773 226.297 269.921 226.417 270.026 226.577C270.13 226.738 270.187 226.93 270.187 227.126C270.187 227.323 270.13 227.515 270.026 227.676C269.921 227.836 269.773 227.956 269.603 228.019L264.804 231.07C264.368 231.315 263.884 231.443 263.394 231.443C262.904 231.443 262.421 231.315 261.985 231.07L257.154 228.019C256.984 227.956 256.836 227.836 256.731 227.676C256.626 227.515 256.57 227.323 256.57 227.126C256.57 226.93 256.626 226.738 256.731 226.577C256.836 226.417 256.984 226.297 257.154 226.233L261.953 223.185C262.391 222.945 262.873 222.82 263.363 222.82C263.852 222.82 264.335 222.945 264.772 223.185L269.603 226.233Z",
    fill: "url(#paint57_linear_6_1917)"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M149.128 186.757C149.299 186.821 149.447 186.941 149.552 187.101C149.657 187.261 149.713 187.453 149.713 187.65C149.713 187.847 149.657 188.039 149.552 188.199C149.447 188.359 149.299 188.479 149.128 188.543L144.33 191.592C143.893 191.833 143.41 191.958 142.92 191.958C142.431 191.958 141.948 191.833 141.51 191.592L136.667 188.533C136.498 188.469 136.351 188.349 136.247 188.19C136.143 188.031 136.087 187.84 136.087 187.644C136.087 187.448 136.143 187.258 136.247 187.098C136.351 186.939 136.498 186.819 136.667 186.755L141.465 183.704C141.9 183.461 142.381 183.334 142.868 183.334C143.356 183.334 143.837 183.461 144.271 183.704L149.128 186.757Z",
    fill: "url(#paint58_linear_6_1917)"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M158.752 180.65C158.923 180.714 159.071 180.834 159.176 180.994C159.281 181.154 159.337 181.346 159.337 181.543C159.337 181.74 159.281 181.932 159.176 182.092C159.071 182.252 158.923 182.373 158.752 182.436L153.954 185.487C153.516 185.727 153.033 185.852 152.544 185.852C152.055 185.852 151.572 185.727 151.134 185.487L146.291 182.429C146.122 182.365 145.975 182.245 145.871 182.085C145.767 181.926 145.711 181.735 145.711 181.54C145.711 181.344 145.767 181.153 145.871 180.993C145.975 180.834 146.122 180.714 146.291 180.65L151.089 177.599C151.524 177.357 152.005 177.23 152.492 177.23C152.98 177.23 153.461 177.357 153.895 177.599L158.752 180.65Z",
    fill: "url(#paint59_linear_6_1917)"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M240.712 244.584C241.498 245.075 241.503 245.873 240.712 246.369L235.914 249.421C235.477 249.664 234.994 249.79 234.504 249.79C234.014 249.79 233.531 249.664 233.094 249.421L228.264 246.369C228.095 246.305 227.948 246.184 227.844 246.024C227.74 245.864 227.684 245.673 227.684 245.476C227.684 245.28 227.74 245.089 227.844 244.929C227.948 244.769 228.095 244.648 228.264 244.584L233.063 241.535C233.499 241.292 233.983 241.166 234.472 241.166C234.962 241.166 235.445 241.292 235.882 241.535L240.712 244.584Z",
    fill: "url(#paint60_linear_6_1917)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M250.338 238.469C251.127 238.961 251.131 239.759 250.338 240.255L245.54 243.306C245.103 243.549 244.62 243.676 244.13 243.676C243.64 243.676 243.157 243.549 242.72 243.306L237.891 240.255C237.721 240.191 237.574 240.07 237.47 239.91C237.366 239.75 237.311 239.558 237.311 239.362C237.311 239.166 237.366 238.975 237.47 238.815C237.574 238.655 237.721 238.534 237.891 238.469L242.689 235.421C243.126 235.178 243.609 235.051 244.099 235.051C244.589 235.051 245.072 235.178 245.508 235.421L250.338 238.469Z",
    fill: "url(#paint61_linear_6_1917)"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M168.395 173.637C168.564 173.702 168.711 173.822 168.815 173.982C168.919 174.142 168.974 174.333 168.974 174.53C168.974 174.726 168.919 174.917 168.815 175.077C168.711 175.237 168.564 175.358 168.395 175.423L163.582 178.481C163.147 178.722 162.667 178.847 162.179 178.847C161.692 178.847 161.211 178.722 160.776 178.481L155.933 175.423C155.764 175.36 155.617 175.241 155.513 175.083C155.409 174.924 155.353 174.734 155.353 174.538C155.353 174.343 155.409 174.153 155.513 173.994C155.617 173.835 155.764 173.717 155.933 173.654L160.745 170.596C161.18 170.355 161.661 170.229 162.148 170.229C162.635 170.229 163.116 170.355 163.551 170.596L168.395 173.637Z",
    fill: "url(#paint62_linear_6_1917)"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M178.019 167.52C178.188 167.585 178.335 167.705 178.439 167.865C178.543 168.025 178.599 168.217 178.599 168.413C178.599 168.609 178.543 168.801 178.439 168.961C178.335 169.121 178.188 169.241 178.019 169.306L173.22 172.355C172.783 172.597 172.301 172.724 171.811 172.724C171.321 172.724 170.837 172.597 170.401 172.355L165.557 169.296C165.387 169.233 165.239 169.114 165.134 168.954C165.03 168.795 164.973 168.603 164.973 168.407C164.973 168.21 165.03 168.019 165.134 167.859C165.239 167.7 165.387 167.58 165.557 167.518L170.358 164.466C170.793 164.226 171.274 164.1 171.761 164.1C172.249 164.1 172.729 164.226 173.164 164.466L178.019 167.52Z",
    fill: "url(#paint63_linear_6_1917)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M259.432 218.92C259.602 218.985 259.749 219.106 259.852 219.266C259.956 219.426 260.012 219.617 260.012 219.813C260.012 220.009 259.956 220.201 259.852 220.361C259.749 220.521 259.602 220.642 259.432 220.706L254.634 223.757C254.196 224 253.713 224.127 253.223 224.127C252.733 224.127 252.249 224 251.812 223.757L246.982 220.706C246.193 220.215 246.191 219.417 246.982 218.92L251.783 215.869C252.22 215.626 252.702 215.5 253.192 215.5C253.682 215.5 254.166 215.626 254.602 215.869L259.432 218.92Z",
    fill: "url(#paint64_linear_6_1917)"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M239.627 218.608C239.798 218.672 239.946 218.792 240.05 218.952C240.155 219.112 240.212 219.304 240.212 219.501C240.212 219.698 240.155 219.89 240.05 220.05C239.946 220.21 239.798 220.331 239.627 220.394L234.815 223.453C234.38 223.696 233.899 223.823 233.411 223.823C232.923 223.823 232.442 223.696 232.007 223.453L227.177 220.404C226.389 219.913 226.386 219.114 227.155 218.626L231.967 215.567C232.403 215.324 232.886 215.198 233.376 215.198C233.866 215.198 234.349 215.324 234.786 215.567L239.627 218.608Z",
    fill: "url(#paint65_linear_6_1917)"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M249.251 212.489C249.422 212.553 249.57 212.673 249.675 212.833C249.779 212.993 249.836 213.185 249.836 213.382C249.836 213.579 249.779 213.771 249.675 213.931C249.57 214.091 249.422 214.211 249.251 214.275L244.453 217.324C244.017 217.569 243.533 217.696 243.043 217.696C242.553 217.696 242.069 217.569 241.633 217.324L236.803 214.275C236.015 213.784 236.012 212.985 236.803 212.489L241.602 209.441C242.038 209.198 242.522 209.071 243.012 209.071C243.502 209.071 243.984 209.198 244.421 209.441L249.251 212.489Z",
    fill: "url(#paint66_linear_6_1917)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M229.457 212.189C229.626 212.253 229.773 212.373 229.877 212.533C229.981 212.692 230.036 212.883 230.036 213.079C230.036 213.274 229.981 213.465 229.877 213.625C229.773 213.784 229.626 213.904 229.457 213.968L224.645 217.026C224.212 217.267 223.734 217.393 223.248 217.393C222.762 217.393 222.283 217.267 221.85 217.026L217.007 213.968C216.232 213.477 216.214 212.678 216.985 212.189L221.797 209.131C222.234 208.891 222.717 208.766 223.206 208.766C223.696 208.766 224.178 208.891 224.616 209.131L229.457 212.189Z",
    fill: "url(#paint67_linear_6_1917)"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M239.084 206.073C239.253 206.137 239.4 206.257 239.504 206.416C239.607 206.575 239.663 206.766 239.663 206.962C239.663 207.158 239.607 207.348 239.504 207.508C239.4 207.667 239.253 207.787 239.084 207.851L234.285 210.9C233.851 211.142 233.37 211.269 232.882 211.269C232.394 211.269 231.914 211.142 231.479 210.9L226.636 207.841C226.465 207.778 226.317 207.658 226.212 207.498C226.107 207.338 226.051 207.146 226.051 206.949C226.051 206.752 226.107 206.559 226.212 206.399C226.317 206.239 226.465 206.119 226.636 206.056L231.434 203.007C231.871 202.766 232.354 202.64 232.844 202.64C233.334 202.64 233.816 202.766 234.254 203.007L239.084 206.073Z",
    fill: "url(#paint68_linear_6_1917)"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M189.285 199.037C189.456 199.101 189.604 199.221 189.709 199.381C189.813 199.541 189.869 199.733 189.869 199.93C189.869 200.127 189.813 200.319 189.709 200.479C189.604 200.639 189.456 200.759 189.285 200.823L184.487 203.874C184.049 204.114 183.566 204.239 183.077 204.239C182.587 204.239 182.105 204.114 181.667 203.874L176.824 200.816C176.654 200.751 176.507 200.63 176.403 200.47C176.299 200.31 176.244 200.119 176.244 199.923C176.244 199.726 176.299 199.535 176.403 199.375C176.507 199.215 176.654 199.094 176.824 199.03L181.622 195.981C182.059 195.738 182.542 195.612 183.032 195.612C183.522 195.612 184.005 195.738 184.442 195.981L189.285 199.037Z",
    fill: "url(#paint69_linear_6_1917)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M199.453 205.459C200.239 205.95 200.243 206.748 199.453 207.245L194.654 210.295C194.217 210.538 193.734 210.665 193.244 210.665C192.754 210.665 192.271 210.538 191.835 210.295L187.005 207.245C186.835 207.18 186.688 207.059 186.584 206.899C186.481 206.739 186.425 206.548 186.425 206.352C186.425 206.155 186.481 205.964 186.584 205.804C186.688 205.644 186.835 205.523 187.005 205.459L191.803 202.407C192.24 202.164 192.723 202.038 193.213 202.038C193.703 202.038 194.186 202.164 194.622 202.407L199.453 205.459Z",
    fill: "url(#paint70_linear_6_1917)"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M209.092 199.334C209.263 199.398 209.411 199.518 209.516 199.678C209.621 199.839 209.677 200.03 209.677 200.227C209.677 200.424 209.621 200.616 209.516 200.776C209.411 200.937 209.263 201.057 209.092 201.12L204.28 204.179C203.846 204.422 203.365 204.549 202.877 204.549C202.39 204.549 201.909 204.422 201.475 204.179L196.644 201.13C195.872 200.639 195.854 199.841 196.622 199.354L201.434 196.296C201.871 196.056 202.354 195.931 202.844 195.931C203.333 195.931 203.816 196.056 204.253 196.296L209.092 199.334Z",
    fill: "url(#paint71_linear_6_1917)"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M230.542 237.278C230.713 237.341 230.861 237.462 230.966 237.622C231.07 237.782 231.127 237.974 231.127 238.171C231.127 238.368 231.07 238.56 230.966 238.72C230.861 238.88 230.713 239 230.542 239.064L225.744 242.115C225.306 242.355 224.824 242.48 224.334 242.48C223.845 242.48 223.362 242.355 222.924 242.115L218.094 239.064C217.924 239 217.776 238.88 217.671 238.72C217.566 238.56 217.51 238.368 217.51 238.171C217.51 237.974 217.566 237.782 217.671 237.622C217.776 237.462 217.924 237.341 218.094 237.278L222.893 234.227C223.329 233.982 223.812 233.854 224.303 233.854C224.793 233.854 225.276 233.982 225.712 234.227L230.542 237.278Z",
    fill: "url(#paint72_linear_6_1917)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M240.166 231.164C240.337 231.227 240.485 231.348 240.59 231.508C240.694 231.668 240.751 231.86 240.751 232.057C240.751 232.254 240.694 232.446 240.59 232.606C240.485 232.766 240.337 232.886 240.166 232.95L235.365 236.001C234.928 236.24 234.445 236.366 233.956 236.366C233.466 236.366 232.984 236.24 232.546 236.001L227.716 232.95C227.546 232.886 227.397 232.766 227.293 232.606C227.188 232.446 227.131 232.254 227.131 232.057C227.131 231.86 227.188 231.668 227.293 231.508C227.397 231.348 227.546 231.227 227.716 231.164L232.515 228.113C232.951 227.868 233.434 227.74 233.924 227.74C234.415 227.74 234.898 227.868 235.334 228.113L240.166 231.164Z",
    fill: "url(#paint73_linear_6_1917)"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M210.195 224.43C210.365 224.493 210.514 224.613 210.618 224.772C210.723 224.932 210.779 225.123 210.779 225.319C210.779 225.516 210.723 225.707 210.618 225.867C210.514 226.026 210.365 226.146 210.195 226.209L205.397 229.257C204.962 229.498 204.481 229.624 203.994 229.624C203.506 229.624 203.026 229.498 202.591 229.257L197.747 226.199C197.578 226.134 197.431 226.013 197.327 225.853C197.223 225.693 197.167 225.502 197.167 225.306C197.167 225.11 197.223 224.918 197.327 224.758C197.431 224.598 197.578 224.478 197.747 224.413L202.546 221.364C202.983 221.122 203.466 220.995 203.956 220.995C204.446 220.995 204.928 221.122 205.365 221.364L210.195 224.43Z",
    fill: "url(#paint74_linear_6_1917)"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M220.368 230.849C221.154 231.341 221.159 232.139 220.368 232.635L215.567 235.686C215.13 235.929 214.647 236.055 214.157 236.055C213.667 236.055 213.185 235.929 212.748 235.686L207.918 232.635C207.747 232.572 207.599 232.451 207.494 232.291C207.389 232.131 207.333 231.939 207.333 231.742C207.333 231.545 207.389 231.353 207.494 231.193C207.599 231.033 207.747 230.913 207.918 230.849L212.716 227.801C213.152 227.556 213.635 227.428 214.126 227.428C214.616 227.428 215.099 227.556 215.536 227.801L220.368 230.849Z",
    fill: "url(#paint75_linear_6_1917)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M229.985 224.732C230.772 225.224 230.776 226.022 229.985 226.518L225.187 229.569C224.75 229.812 224.267 229.939 223.777 229.939C223.287 229.939 222.804 229.812 222.367 229.569L217.537 226.518C217.367 226.455 217.219 226.335 217.114 226.174C217.009 226.014 216.953 225.822 216.953 225.625C216.953 225.428 217.009 225.236 217.114 225.076C217.219 224.916 217.367 224.796 217.537 224.732L222.338 221.684C222.774 221.439 223.258 221.311 223.748 221.311C224.238 221.311 224.721 221.439 225.157 221.684L229.985 224.732Z",
    fill: "url(#paint76_linear_6_1917)"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M219.82 218.313C219.99 218.376 220.138 218.496 220.242 218.655C220.347 218.815 220.404 219.006 220.404 219.203C220.404 219.399 220.347 219.591 220.242 219.75C220.138 219.91 219.99 220.029 219.82 220.092L215.021 223.141C214.586 223.382 214.105 223.507 213.618 223.507C213.131 223.507 212.65 223.382 212.215 223.141L207.372 220.082C207.202 220.018 207.055 219.897 206.951 219.737C206.847 219.577 206.792 219.386 206.792 219.189C206.792 218.993 206.847 218.802 206.951 218.642C207.055 218.482 207.202 218.361 207.372 218.296L212.172 215.248C212.609 215.005 213.092 214.878 213.582 214.878C214.072 214.878 214.555 215.005 214.992 215.248L219.82 218.313Z",
    fill: "url(#paint77_linear_6_1917)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M189.82 211.575C190.606 212.067 190.611 212.865 189.82 213.361L185.019 216.41C184.582 216.653 184.099 216.779 183.609 216.779C183.119 216.779 182.636 216.653 182.2 216.41L177.37 213.361C177.2 213.297 177.053 213.176 176.949 213.016C176.845 212.856 176.79 212.665 176.79 212.468C176.79 212.272 176.845 212.081 176.949 211.921C177.053 211.761 177.2 211.64 177.37 211.575L182.168 208.524C182.605 208.281 183.088 208.155 183.578 208.155C184.068 208.155 184.551 208.281 184.987 208.524L189.82 211.575Z",
    fill: "url(#paint78_linear_6_1917)"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M200.012 218.002C200.183 218.065 200.331 218.185 200.436 218.346C200.54 218.506 200.597 218.698 200.597 218.895C200.597 219.092 200.54 219.284 200.436 219.444C200.331 219.604 200.183 219.724 200.012 219.788L195.214 222.836C194.776 223.077 194.294 223.203 193.804 223.203C193.314 223.203 192.831 223.077 192.394 222.836L187.562 219.788C187.391 219.724 187.244 219.604 187.139 219.444C187.034 219.284 186.978 219.092 186.978 218.895C186.978 218.698 187.034 218.506 187.139 218.346C187.244 218.185 187.391 218.065 187.562 218.002L192.361 214.95C192.797 214.706 193.28 214.578 193.77 214.578C194.261 214.578 194.744 214.706 195.18 214.95L200.012 218.002Z",
    fill: "url(#paint79_linear_6_1917)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M220.918 243.397C221.089 243.461 221.237 243.581 221.341 243.741C221.446 243.901 221.503 244.093 221.503 244.29C221.503 244.487 221.446 244.679 221.341 244.839C221.237 244.999 221.089 245.119 220.918 245.183L216.12 248.232C215.683 248.474 215.2 248.601 214.71 248.601C214.22 248.601 213.737 248.474 213.3 248.232L208.47 245.183C207.684 244.692 207.68 243.893 208.47 243.397L213.269 240.348C213.705 240.103 214.188 239.976 214.678 239.976C215.169 239.976 215.652 240.103 216.088 240.348L220.918 243.397Z",
    fill: "url(#paint80_linear_6_1917)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M210.739 236.966C211.525 237.457 211.53 238.256 210.739 238.752L205.941 241.8C205.504 242.046 205.021 242.173 204.531 242.173C204.04 242.173 203.557 242.046 203.121 241.8L199.302 239.383L198.302 238.752L192.965 235.381L188.121 232.323L182.783 228.953L177.953 225.902L167.772 219.473C167.602 219.41 167.454 219.289 167.349 219.129C167.244 218.969 167.188 218.777 167.188 218.58C167.188 218.383 167.244 218.191 167.349 218.031C167.454 217.871 167.602 217.751 167.772 217.687L172.571 214.636C173.007 214.393 173.49 214.267 173.98 214.267C174.47 214.267 174.953 214.393 175.39 214.636L185.571 221.065L190.401 224.114L195.739 227.484L200.583 230.542L205.92 233.912L206.92 234.544L210.739 236.966Z",
    fill: "url(#paint81_linear_6_1917)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M209.636 211.89C209.806 211.953 209.955 212.073 210.059 212.234C210.164 212.394 210.221 212.586 210.221 212.783C210.221 212.98 210.164 213.172 210.059 213.332C209.955 213.492 209.806 213.612 209.636 213.676L204.837 216.724C204.4 216.964 203.917 217.089 203.428 217.089C202.938 217.089 202.456 216.964 202.018 216.724L197.188 213.676C197.017 213.612 196.869 213.492 196.764 213.332C196.66 213.172 196.604 212.98 196.604 212.783C196.604 212.586 196.66 212.394 196.764 212.234C196.869 212.073 197.017 211.953 197.188 211.89L201.986 208.841C202.423 208.596 202.906 208.469 203.396 208.469C203.887 208.469 204.37 208.596 204.806 208.841L209.636 211.89Z",
    fill: "url(#paint82_linear_6_1917)"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M219.274 205.761C219.443 205.825 219.59 205.946 219.694 206.106C219.798 206.266 219.854 206.458 219.854 206.654C219.854 206.85 219.798 207.041 219.694 207.201C219.59 207.361 219.443 207.482 219.274 207.547L214.462 210.605C214.027 210.846 213.546 210.972 213.058 210.972C212.57 210.972 212.089 210.846 211.654 210.605L206.824 207.556C206.037 207.065 206.033 206.267 206.801 205.778L211.613 202.72C212.05 202.477 212.533 202.35 213.023 202.35C213.513 202.35 213.996 202.477 214.433 202.72L219.274 205.761Z",
    fill: "url(#paint83_linear_6_1917)"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M228.897 199.644C229.067 199.708 229.214 199.829 229.318 199.989C229.422 200.149 229.477 200.341 229.477 200.537C229.477 200.733 229.422 200.924 229.318 201.084C229.214 201.244 229.067 201.365 228.897 201.43L224.097 204.481C223.66 204.724 223.177 204.85 222.687 204.85C222.197 204.85 221.714 204.724 221.277 204.481L216.447 201.43C215.659 200.939 215.656 200.14 216.447 199.644L221.246 196.593C221.683 196.35 222.166 196.224 222.656 196.224C223.146 196.224 223.628 196.35 224.065 196.593L228.897 199.644Z",
    fill: "url(#paint84_linear_6_1917)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M218.719 193.215C218.889 193.279 219.038 193.399 219.142 193.559C219.247 193.719 219.304 193.911 219.304 194.108C219.304 194.305 219.247 194.497 219.142 194.657C219.038 194.818 218.889 194.938 218.719 195.001L213.92 198.05C213.484 198.294 213.001 198.422 212.511 198.422C212.021 198.422 211.537 198.294 211.101 198.05L206.271 195.001C206.101 194.938 205.953 194.818 205.848 194.657C205.743 194.497 205.687 194.305 205.687 194.108C205.687 193.911 205.743 193.719 205.848 193.559C205.953 193.399 206.101 193.279 206.271 193.215L211.07 190.164C211.507 189.924 211.99 189.8 212.479 189.8C212.969 189.8 213.452 189.924 213.889 190.164L218.719 193.215Z",
    fill: "url(#paint85_linear_6_1917)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M198.924 192.913C199.094 192.978 199.241 193.099 199.345 193.259C199.449 193.419 199.504 193.61 199.504 193.806C199.504 194.002 199.449 194.194 199.345 194.354C199.241 194.514 199.094 194.634 198.924 194.699L194.112 197.757C193.678 197.999 193.197 198.124 192.709 198.124C192.222 198.124 191.741 197.999 191.307 197.757L186.463 194.699C185.688 194.208 185.672 193.409 186.441 192.921L191.253 189.862C191.69 189.621 192.173 189.495 192.662 189.495C193.152 189.495 193.635 189.621 194.072 189.862L198.924 192.913Z",
    fill: "url(#paint86_linear_6_1917)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M208.551 186.796C208.72 186.861 208.867 186.982 208.971 187.142C209.075 187.302 209.131 187.493 209.131 187.689C209.131 187.886 209.075 188.077 208.971 188.237C208.867 188.397 208.72 188.518 208.551 188.582L203.752 191.631C203.316 191.874 202.833 192 202.343 192C201.853 192 201.37 191.874 200.933 191.631L196.09 188.573C195.919 188.509 195.771 188.389 195.666 188.229C195.561 188.069 195.505 187.877 195.505 187.68C195.505 187.483 195.561 187.291 195.666 187.131C195.771 186.97 195.919 186.85 196.09 186.787L200.888 183.738C201.326 183.498 201.808 183.373 202.298 183.373C202.787 183.373 203.27 183.498 203.707 183.738L208.551 186.796Z",
    fill: "url(#paint87_linear_6_1917)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M139.504 191.994C139.675 192.058 139.823 192.178 139.927 192.338C140.032 192.498 140.089 192.69 140.089 192.887C140.089 193.084 140.032 193.276 139.927 193.436C139.823 193.596 139.675 193.717 139.504 193.78L134.706 196.829C134.269 197.072 133.786 197.198 133.296 197.198C132.806 197.198 132.323 197.072 131.886 196.829L127.043 193.77C126.872 193.708 126.725 193.588 126.62 193.429C126.515 193.269 126.458 193.078 126.458 192.881C126.458 192.685 126.515 192.493 126.62 192.334C126.725 192.174 126.872 192.055 127.043 191.992L131.841 188.943C132.276 188.701 132.756 188.574 133.244 188.574C133.732 188.574 134.213 188.701 134.647 188.943L139.504 191.994Z",
    fill: "url(#paint88_linear_6_1917)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M159.299 192.299C160.085 192.79 160.089 193.589 159.299 194.085L154.5 197.134C154.063 197.376 153.58 197.503 153.09 197.503C152.6 197.503 152.117 197.376 151.68 197.134L146.851 194.085C146.681 194.02 146.534 193.9 146.43 193.74C146.326 193.58 146.271 193.388 146.271 193.192C146.271 192.996 146.326 192.805 146.43 192.645C146.534 192.485 146.681 192.364 146.851 192.299L151.649 189.248C152.086 189.005 152.569 188.879 153.059 188.879C153.549 188.879 154.032 189.005 154.468 189.248L159.299 192.299Z",
    fill: "url(#paint89_linear_6_1917)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M149.67 198.416C150.458 198.907 150.46 199.706 149.67 200.202L144.871 203.25C144.435 203.495 143.952 203.623 143.462 203.623C142.971 203.623 142.488 203.495 142.052 203.25L137.222 200.202C137.051 200.138 136.903 200.018 136.798 199.858C136.694 199.698 136.637 199.506 136.637 199.309C136.637 199.112 136.694 198.92 136.798 198.76C136.903 198.6 137.051 198.479 137.222 198.416L142.02 195.365C142.457 195.122 142.94 194.995 143.43 194.995C143.92 194.995 144.403 195.122 144.84 195.365L149.67 198.416Z",
    fill: "url(#paint90_linear_6_1917)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M169.478 198.725C169.648 198.789 169.796 198.909 169.901 199.069C170.005 199.229 170.062 199.421 170.062 199.618C170.062 199.815 170.005 200.007 169.901 200.167C169.796 200.327 169.648 200.448 169.478 200.511L164.679 203.562C164.241 203.802 163.759 203.927 163.269 203.927C162.78 203.927 162.297 203.802 161.86 203.562L157.029 200.511C156.859 200.448 156.711 200.327 156.606 200.167C156.501 200.007 156.445 199.815 156.445 199.618C156.445 199.421 156.501 199.229 156.606 199.069C156.711 198.909 156.859 198.789 157.029 198.725L161.83 195.677C162.266 195.431 162.75 195.304 163.24 195.304C163.73 195.304 164.214 195.431 164.65 195.677L169.478 198.725Z",
    fill: "url(#paint91_linear_6_1917)"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M159.853 204.842C160.024 204.906 160.172 205.026 160.277 205.186C160.381 205.346 160.438 205.538 160.438 205.735C160.438 205.932 160.381 206.124 160.277 206.284C160.172 206.444 160.024 206.564 159.853 206.628L155.055 209.677C154.618 209.919 154.135 210.046 153.645 210.046C153.155 210.046 152.672 209.919 152.235 209.677L147.405 206.628C146.617 206.136 146.614 205.338 147.405 204.842L152.204 201.791C152.64 201.546 153.123 201.418 153.613 201.418C154.104 201.418 154.587 201.546 155.023 201.791L159.853 204.842Z",
    fill: "url(#paint92_linear_6_1917)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M179.658 205.154C179.829 205.217 179.977 205.338 180.082 205.498C180.187 205.658 180.243 205.85 180.243 206.047C180.243 206.244 180.187 206.436 180.082 206.596C179.977 206.756 179.829 206.876 179.658 206.94L174.86 209.991C174.423 210.232 173.94 210.358 173.45 210.358C172.961 210.358 172.478 210.232 172.04 209.991L167.197 206.932C167.027 206.868 166.881 206.747 166.777 206.587C166.673 206.427 166.617 206.236 166.617 206.039C166.617 205.843 166.673 205.652 166.777 205.492C166.881 205.332 167.027 205.211 167.197 205.147L171.998 202.098C172.435 201.855 172.917 201.728 173.407 201.728C173.897 201.728 174.38 201.855 174.817 202.098L179.658 205.154Z",
    fill: "url(#paint93_linear_6_1917)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M170.037 211.271C170.207 211.334 170.355 211.454 170.46 211.615C170.565 211.775 170.621 211.967 170.621 212.164C170.621 212.361 170.565 212.553 170.46 212.713C170.355 212.873 170.207 212.993 170.037 213.057L165.238 216.108C164.801 216.351 164.318 216.477 163.828 216.477C163.339 216.477 162.855 216.351 162.419 216.108L157.575 213.049C157.405 212.986 157.257 212.866 157.152 212.706C157.047 212.545 156.991 212.353 156.991 212.156C156.991 211.96 157.047 211.768 157.152 211.607C157.257 211.447 157.405 211.327 157.575 211.263L162.374 208.212C162.81 207.97 163.294 207.843 163.783 207.843C164.273 207.843 164.756 207.97 165.193 208.212L170.037 211.271Z",
    fill: "url(#paint94_linear_6_1917)"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M179.106 192.608C179.276 192.672 179.424 192.792 179.529 192.952C179.634 193.112 179.69 193.304 179.69 193.501C179.69 193.698 179.634 193.89 179.529 194.05C179.424 194.211 179.276 194.331 179.106 194.394L174.307 197.445C173.87 197.686 173.387 197.812 172.898 197.812C172.408 197.812 171.925 197.686 171.488 197.445L166.658 194.394C166.487 194.331 166.339 194.211 166.234 194.05C166.13 193.89 166.073 193.698 166.073 193.501C166.073 193.304 166.13 193.112 166.234 192.952C166.339 192.792 166.487 192.672 166.658 192.608L171.456 189.558C171.893 189.312 172.376 189.184 172.866 189.184C173.356 189.184 173.84 189.312 174.276 189.558L179.106 192.608Z",
    fill: "url(#paint95_linear_6_1917)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M188.75 186.484C188.919 186.549 189.066 186.67 189.17 186.83C189.274 186.99 189.33 187.181 189.33 187.377C189.33 187.574 189.274 187.765 189.17 187.925C189.066 188.085 188.919 188.206 188.75 188.27L183.936 191.329C183.501 191.57 183.02 191.695 182.533 191.695C182.045 191.695 181.565 191.57 181.13 191.329L176.3 188.28C175.514 187.789 175.509 186.991 176.277 186.502L181.089 183.443C181.526 183.201 182.009 183.074 182.499 183.074C182.989 183.074 183.472 183.201 183.909 183.443L188.75 186.484Z",
    fill: "url(#paint96_linear_6_1917)"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M198.368 180.368C198.536 180.434 198.682 180.555 198.785 180.714C198.888 180.874 198.943 181.065 198.943 181.261C198.943 181.456 198.888 181.647 198.785 181.807C198.682 181.967 198.536 182.088 198.368 182.154L193.569 185.202C193.132 185.445 192.649 185.572 192.159 185.572C191.669 185.572 191.186 185.445 190.75 185.202L185.92 182.154C185.133 181.662 185.129 180.864 185.92 180.368L190.718 177.319C191.155 177.076 191.638 176.95 192.128 176.95C192.618 176.95 193.101 177.076 193.537 177.319L198.368 180.368Z",
    fill: "url(#paint97_linear_6_1917)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M168.92 186.182C169.706 186.674 169.711 187.472 168.92 187.968L164.122 191.017C163.685 191.26 163.202 191.386 162.712 191.386C162.222 191.386 161.739 191.26 161.302 191.017L156.472 187.968C156.303 187.903 156.156 187.783 156.052 187.623C155.948 187.463 155.892 187.271 155.892 187.075C155.892 186.879 155.948 186.688 156.052 186.528C156.156 186.368 156.303 186.247 156.472 186.182L161.271 183.131C161.707 182.888 162.191 182.762 162.68 182.762C163.17 182.762 163.653 182.888 164.09 183.131L168.92 186.182Z",
    fill: "url(#paint98_linear_6_1917)"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M178.562 180.058C178.733 180.122 178.881 180.242 178.986 180.402C179.091 180.562 179.147 180.754 179.147 180.951C179.147 181.148 179.091 181.34 178.986 181.5C178.881 181.66 178.733 181.78 178.562 181.844L173.75 184.902C173.315 185.145 172.834 185.272 172.346 185.272C171.858 185.272 171.377 185.145 170.942 184.902L166.112 181.851C165.337 181.36 165.321 180.562 166.09 180.073L170.902 177.015C171.339 176.775 171.822 176.65 172.311 176.65C172.801 176.65 173.283 176.775 173.721 177.015L178.562 180.058Z",
    fill: "url(#paint99_linear_6_1917)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M188.184 173.941C188.355 174.005 188.503 174.125 188.608 174.285C188.713 174.445 188.769 174.637 188.769 174.834C188.769 175.031 188.713 175.223 188.608 175.383C188.503 175.544 188.355 175.664 188.184 175.727L183.386 178.776C182.95 179.021 182.466 179.149 181.976 179.149C181.486 179.149 181.002 179.021 180.566 178.776L175.736 175.727C175.566 175.664 175.418 175.544 175.313 175.383C175.208 175.223 175.152 175.031 175.152 174.834C175.152 174.637 175.208 174.445 175.313 174.285C175.418 174.125 175.566 174.005 175.736 173.941L180.535 170.89C180.972 170.651 181.455 170.526 181.945 170.526C182.434 170.526 182.917 170.651 183.354 170.89L188.184 173.941Z",
    fill: "url(#paint100_linear_6_1917)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M249.809 225.037C249.978 225.102 250.125 225.222 250.229 225.382C250.333 225.542 250.389 225.734 250.389 225.93C250.389 226.126 250.333 226.318 250.229 226.478C250.125 226.638 249.978 226.758 249.809 226.823L244.997 229.881C244.561 230.123 244.08 230.248 243.593 230.248C243.105 230.248 242.624 230.123 242.188 229.881L237.358 226.833C236.572 226.341 236.568 225.543 237.336 225.054L242.148 221.996C242.585 221.753 243.068 221.626 243.558 221.626C244.048 221.626 244.531 221.753 244.967 221.996L249.809 225.037Z",
    fill: "url(#paint101_linear_6_1917)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M259.976 231.456C260.147 231.519 260.295 231.64 260.4 231.8C260.504 231.96 260.561 232.152 260.561 232.349C260.561 232.546 260.504 232.738 260.4 232.898C260.295 233.058 260.147 233.178 259.976 233.242L255.164 236.3C254.73 236.543 254.249 236.67 253.761 236.67C253.273 236.67 252.792 236.543 252.358 236.3L247.528 233.252C246.755 232.76 246.735 231.962 247.506 231.473L252.318 228.415C252.755 228.175 253.238 228.05 253.727 228.05C254.217 228.05 254.7 228.175 255.137 228.415L259.976 231.456Z",
    fill: "url(#paint102_linear_6_1917)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M231.086 249.814C231.872 250.305 231.877 251.103 231.086 251.599L226.287 254.651C225.851 254.895 225.368 255.023 224.878 255.023C224.387 255.023 223.904 254.895 223.468 254.651L218.638 251.599C218.467 251.536 218.319 251.416 218.214 251.255C218.11 251.095 218.053 250.903 218.053 250.706C218.053 250.51 218.11 250.318 218.214 250.157C218.319 249.997 218.467 249.877 218.638 249.814L223.436 246.763C223.873 246.52 224.356 246.393 224.846 246.393C225.336 246.393 225.819 246.52 226.256 246.763L231.086 249.814Z",
    fill: "url(#paint103_linear_6_1917)"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M241.269 256.242C242.056 256.733 242.06 257.532 241.269 258.028L236.471 261.077C236.035 261.321 235.551 261.449 235.061 261.449C234.571 261.449 234.087 261.321 233.651 261.077L228.821 258.028C228.033 257.537 228.03 256.738 228.821 256.242L233.622 253.191C234.058 252.947 234.542 252.819 235.032 252.819C235.522 252.819 236.005 252.947 236.442 253.191L241.269 256.242Z",
    fill: "url(#paint104_linear_6_1917)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M250.893 250.126C251.682 250.617 251.684 251.415 250.893 251.912L246.095 254.96C245.658 255.203 245.175 255.329 244.685 255.329C244.195 255.329 243.712 255.203 243.275 254.96L238.445 251.912C238.275 251.848 238.127 251.728 238.022 251.568C237.917 251.407 237.861 251.215 237.861 251.019C237.861 250.822 237.917 250.63 238.022 250.469C238.127 250.309 238.275 250.189 238.445 250.126L243.244 247.074C243.68 246.829 244.163 246.702 244.654 246.702C245.144 246.702 245.627 246.829 246.063 247.074L250.893 250.126Z",
    fill: "url(#paint105_linear_6_1917)"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M251.45 262.669C251.621 262.732 251.769 262.852 251.874 263.012C251.979 263.173 252.035 263.365 252.035 263.562C252.035 263.758 251.979 263.95 251.874 264.111C251.769 264.271 251.621 264.391 251.45 264.455L246.652 267.505C246.215 267.748 245.732 267.875 245.242 267.875C244.752 267.875 244.269 267.748 243.832 267.505L238.989 264.447C238.818 264.384 238.67 264.263 238.566 264.103C238.461 263.943 238.404 263.751 238.404 263.554C238.404 263.357 238.461 263.165 238.566 263.005C238.67 262.845 238.818 262.724 238.989 262.661L243.788 259.613C244.224 259.37 244.707 259.243 245.197 259.243C245.687 259.243 246.17 259.37 246.607 259.613L251.45 262.669Z",
    fill: "url(#paint106_linear_6_1917)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M261.075 256.552C261.245 256.615 261.393 256.735 261.498 256.896C261.603 257.056 261.659 257.248 261.659 257.445C261.659 257.642 261.603 257.834 261.498 257.994C261.393 258.154 261.245 258.274 261.075 258.338L256.276 261.389C255.839 261.629 255.356 261.753 254.866 261.753C254.377 261.753 253.894 261.629 253.457 261.389L248.613 258.33C248.444 258.266 248.297 258.145 248.193 257.985C248.089 257.825 248.033 257.634 248.033 257.437C248.033 257.241 248.089 257.05 248.193 256.89C248.297 256.73 248.444 256.609 248.613 256.544L253.412 253.496C253.848 253.253 254.331 253.126 254.821 253.126C255.311 253.126 255.794 253.253 256.231 253.496L261.075 256.552Z",
    fill: "url(#paint107_linear_6_1917)"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M270.16 237.885C270.33 237.948 270.478 238.068 270.583 238.228C270.688 238.389 270.744 238.581 270.744 238.778C270.744 238.974 270.688 239.166 270.583 239.327C270.478 239.487 270.33 239.607 270.16 239.671L265.348 242.729C264.913 242.972 264.433 243.098 263.945 243.098C263.457 243.098 262.976 242.972 262.542 242.729L257.712 239.68C256.926 239.189 256.921 238.391 257.689 237.902L262.501 234.844C262.938 234.601 263.421 234.474 263.911 234.474C264.401 234.474 264.884 234.601 265.321 234.844L270.16 237.885Z",
    fill: "url(#paint108_linear_6_1917)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M280.339 244.306C280.507 244.372 280.653 244.493 280.756 244.653C280.859 244.813 280.914 245.004 280.914 245.199C280.914 245.395 280.859 245.585 280.756 245.745C280.653 245.905 280.507 246.026 280.339 246.092L275.527 249.15C275.092 249.391 274.611 249.517 274.124 249.517C273.636 249.517 273.156 249.391 272.721 249.15L267.877 246.092C267.102 245.6 267.086 244.802 267.855 244.313L272.667 241.255C273.105 241.015 273.587 240.89 274.077 240.89C274.566 240.89 275.049 241.015 275.486 241.255L280.339 244.306Z",
    fill: "url(#paint109_linear_6_1917)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M270.701 250.437C270.872 250.501 271.019 250.621 271.124 250.781C271.229 250.942 271.286 251.134 271.286 251.33C271.286 251.527 271.229 251.719 271.124 251.88C271.019 252.04 270.872 252.16 270.701 252.224L265.903 255.274C265.465 255.514 264.982 255.639 264.493 255.639C264.003 255.639 263.521 255.514 263.083 255.274L252.902 248.846L251.195 247.767L248.072 245.802C247.901 245.739 247.753 245.618 247.649 245.458C247.544 245.298 247.487 245.106 247.487 244.909C247.487 244.712 247.544 244.52 247.649 244.36C247.753 244.2 247.901 244.08 248.072 244.016L252.871 240.968C253.307 240.722 253.79 240.595 254.28 240.595C254.77 240.595 255.254 240.722 255.69 240.968L258.813 242.933L260.52 244.011L270.701 250.437Z",
    fill: "url(#paint110_linear_6_1917)"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M289.963 238.197C290.132 238.261 290.279 238.382 290.383 238.542C290.487 238.702 290.543 238.893 290.543 239.09C290.543 239.286 290.487 239.477 290.383 239.637C290.279 239.797 290.132 239.918 289.963 239.983L285.164 243.033C284.728 243.276 284.244 243.403 283.754 243.403C283.264 243.403 282.781 243.276 282.345 243.033L277.501 239.975C277.331 239.912 277.183 239.791 277.078 239.631C276.973 239.471 276.917 239.279 276.917 239.082C276.917 238.885 276.973 238.693 277.078 238.533C277.183 238.373 277.331 238.253 277.501 238.189L282.302 235.138C282.74 234.898 283.223 234.773 283.713 234.773C284.203 234.773 284.686 234.898 285.124 235.138L289.963 238.197Z",
    fill: "url(#paint111_linear_6_1917)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M279.784 231.768C279.954 231.831 280.102 231.952 280.207 232.112C280.312 232.272 280.368 232.464 280.368 232.661C280.368 232.858 280.312 233.05 280.207 233.21C280.102 233.37 279.954 233.49 279.784 233.554L274.985 236.605C274.549 236.85 274.065 236.978 273.574 236.978C273.084 236.978 272.6 236.85 272.163 236.605L267.333 233.554C266.545 233.063 266.543 232.264 267.333 231.768L272.132 228.717C272.569 228.474 273.052 228.347 273.542 228.347C274.032 228.347 274.514 228.474 274.951 228.717L279.784 231.768Z",
    fill: "url(#paint112_linear_6_1917)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M269.603 225.342C269.773 225.405 269.921 225.526 270.026 225.686C270.13 225.846 270.187 226.038 270.187 226.235C270.187 226.432 270.13 226.624 270.026 226.784C269.921 226.944 269.773 227.064 269.603 227.127L264.804 230.176C264.368 230.421 263.884 230.549 263.394 230.549C262.904 230.549 262.421 230.421 261.985 230.176L257.154 227.127C256.984 227.064 256.836 226.944 256.731 226.784C256.626 226.624 256.57 226.432 256.57 226.235C256.57 226.038 256.626 225.846 256.731 225.686C256.836 225.526 256.984 225.405 257.154 225.342L261.953 222.291C262.391 222.051 262.873 221.926 263.363 221.926C263.852 221.926 264.335 222.051 264.772 222.291L269.603 225.342Z",
    fill: "url(#paint113_linear_6_1917)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M149.128 185.878C149.299 185.941 149.447 186.061 149.552 186.222C149.657 186.382 149.713 186.574 149.713 186.771C149.713 186.968 149.657 187.16 149.552 187.32C149.447 187.48 149.299 187.6 149.128 187.664L144.33 190.712C143.893 190.953 143.41 191.079 142.92 191.079C142.431 191.079 141.948 190.953 141.51 190.712L136.667 187.654C136.498 187.59 136.351 187.47 136.247 187.31C136.143 187.151 136.087 186.96 136.087 186.764C136.087 186.569 136.143 186.378 136.247 186.219C136.351 186.059 136.498 185.939 136.667 185.875L141.465 182.826C141.9 182.583 142.381 182.457 142.868 182.457C143.356 182.457 143.837 182.583 144.271 182.826L149.128 185.878Z",
    fill: "url(#paint114_linear_6_1917)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M158.752 179.764C158.923 179.827 159.071 179.947 159.176 180.107C159.281 180.267 159.337 180.459 159.337 180.656C159.337 180.853 159.281 181.045 159.176 181.205C159.071 181.365 158.923 181.486 158.752 181.549L153.954 184.598C153.516 184.838 153.033 184.963 152.544 184.963C152.055 184.963 151.572 184.838 151.134 184.598L146.291 181.539C146.122 181.475 145.975 181.356 145.871 181.196C145.767 181.037 145.711 180.846 145.711 180.65C145.711 180.455 145.767 180.264 145.871 180.104C145.975 179.945 146.122 179.825 146.291 179.761L151.089 176.71C151.524 176.467 152.005 176.341 152.492 176.341C152.98 176.341 153.461 176.467 153.895 176.71L158.752 179.764Z",
    fill: "url(#paint115_linear_6_1917)"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M240.712 243.697C241.498 244.188 241.503 244.987 240.712 245.483L235.914 248.534C235.477 248.776 234.994 248.903 234.504 248.903C234.014 248.903 233.531 248.776 233.094 248.534L228.264 245.483C228.095 245.418 227.948 245.297 227.844 245.137C227.74 244.977 227.684 244.786 227.684 244.59C227.684 244.393 227.74 244.202 227.844 244.042C227.948 243.882 228.095 243.761 228.264 243.697L233.063 240.646C233.499 240.403 233.983 240.276 234.472 240.276C234.962 240.276 235.445 240.403 235.882 240.646L240.712 243.697Z",
    fill: "url(#paint116_linear_6_1917)"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M250.338 237.58C251.127 238.071 251.131 238.87 250.338 239.366L245.54 242.417C245.103 242.66 244.62 242.786 244.13 242.786C243.64 242.786 243.157 242.66 242.72 242.417L237.891 239.366C237.721 239.301 237.574 239.181 237.47 239.021C237.366 238.861 237.311 238.669 237.311 238.473C237.311 238.277 237.366 238.086 237.47 237.926C237.574 237.766 237.721 237.645 237.891 237.58L242.689 234.532C243.126 234.289 243.609 234.162 244.099 234.162C244.589 234.162 245.072 234.289 245.508 234.532L250.338 237.58Z",
    fill: "url(#paint117_linear_6_1917)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M260.901 268.439C262.263 252.657 231.772 236.601 192.796 232.579C153.82 228.557 121.12 238.091 119.758 253.873C118.395 269.656 148.887 285.712 187.863 289.734C226.839 293.756 259.539 284.222 260.901 268.439Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.039,
    d: "M259.581 268.215C260.925 252.643 230.912 236.81 192.546 232.85C154.179 228.891 121.988 238.305 120.644 253.877C119.3 269.449 149.312 285.282 187.679 289.242C226.045 293.201 258.237 283.787 259.581 268.215Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.059,
    d: "M258.259 267.988C259.585 252.626 230.051 237.013 192.294 233.117C154.536 229.22 122.853 238.515 121.527 253.878C120.201 269.24 149.735 284.853 187.492 288.75C225.249 292.646 256.933 283.351 258.259 267.988Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.078,
    d: "M256.939 267.764C258.246 252.611 229.192 237.219 192.044 233.385C154.896 229.552 123.721 238.728 122.414 253.881C121.106 269.034 150.16 284.426 187.308 288.26C224.456 292.094 255.631 282.917 256.939 267.764Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.098,
    d: "M255.538 267.569C256.832 252.632 228.274 237.456 191.752 233.674C155.23 229.891 124.574 238.933 123.28 253.87C121.986 268.807 150.544 283.982 187.066 287.765C223.588 291.548 254.244 282.506 255.538 267.569Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.118,
    d: "M254.219 267.343C255.495 252.616 227.416 237.661 191.502 233.942C155.589 230.222 125.442 239.146 124.166 253.873C122.89 268.601 150.969 283.555 186.883 287.275C222.796 290.995 252.943 282.071 254.219 267.343Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.137,
    d: "M252.9 267.116C254.158 252.598 226.557 237.864 191.253 234.207C155.949 230.551 126.31 239.356 125.052 253.874C123.794 268.392 151.395 283.126 186.699 286.782C222.003 290.439 251.642 281.634 252.9 267.116Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.157,
    d: "M251.581 266.893C252.82 252.586 225.699 238.074 191.003 234.48C156.308 230.887 127.177 239.572 125.938 253.88C124.699 268.187 151.82 282.699 186.515 286.292C221.21 289.886 250.341 281.201 251.581 266.893Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.176,
    d: "M250.261 266.668C251.482 252.57 224.84 238.279 190.754 234.748C156.667 231.218 128.045 239.785 126.824 253.883C125.602 267.981 152.245 282.272 186.331 285.802C220.417 289.333 249.04 280.766 250.261 266.668Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.196,
    d: "M248.941 266.377C250.143 252.488 223.978 238.421 190.5 234.958C157.022 231.494 128.909 239.945 127.707 253.834C126.505 267.723 152.67 281.79 186.148 285.254C219.626 288.717 247.739 280.266 248.941 266.377Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.216,
    d: "M247.622 266.152C248.805 252.473 223.119 238.626 190.251 235.226C157.382 231.825 129.777 240.158 128.593 253.837C127.41 267.517 153.096 281.363 185.964 284.764C218.833 288.164 246.438 279.832 247.622 266.152Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.235,
    d: "M246.305 265.927C247.47 252.457 222.263 238.832 190.003 235.494C157.744 232.156 130.647 240.37 129.481 253.841C128.316 267.311 153.523 280.936 185.783 284.274C218.042 287.611 245.139 279.397 246.305 265.927Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.255,
    d: "M244.959 265.664C246.106 252.403 221.376 239.002 189.725 235.731C158.074 232.46 131.487 240.558 130.34 253.819C129.194 267.08 153.923 280.482 185.575 283.753C217.226 287.024 243.813 278.925 244.959 265.664Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.275,
    d: "M243.643 265.445C244.771 252.394 220.52 239.214 189.478 236.006C158.436 232.798 132.357 240.777 131.229 253.827C130.101 266.877 154.351 280.057 185.393 283.265C216.436 286.474 242.515 278.495 243.643 265.445Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.294,
    d: "M242.325 265.222C243.435 252.381 219.664 239.422 189.231 236.277C158.798 233.132 133.227 240.992 132.117 253.833C131.007 266.674 154.778 279.633 185.212 282.778C215.645 285.923 241.216 278.063 242.325 265.222Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.314,
    d: "M240.983 264.965C242.074 252.333 218.78 239.597 188.956 236.518C159.131 233.438 134.07 241.182 132.979 253.814C131.888 266.445 155.181 279.182 185.006 282.261C214.831 285.34 239.892 277.597 240.983 264.965Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M239.666 264.743C240.739 252.321 217.924 239.805 188.709 236.789C159.493 233.772 134.94 241.397 133.867 253.819C132.794 266.242 155.609 278.757 184.824 281.774C214.04 284.79 238.593 277.165 239.666 264.743Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.353,
    d: "M238.351 264.523C239.406 252.31 217.071 240.016 188.464 237.062C159.857 234.108 135.812 241.615 134.758 253.828C133.703 266.04 156.038 278.335 184.645 281.289C213.252 284.243 237.297 276.736 238.351 264.523Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.373,
    d: "M237.009 264.265C238.044 252.261 216.187 240.19 188.189 237.302C160.191 234.415 136.655 241.805 135.619 253.808C134.584 265.812 156.441 277.884 184.439 280.771C212.437 283.659 235.973 276.269 237.009 264.265Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.392,
    d: "M235.694 264.048C236.711 252.255 215.333 240.405 187.944 237.581C160.555 234.756 137.527 242.026 136.51 253.819C135.493 265.612 156.871 277.462 184.26 280.287C211.649 283.112 234.677 275.841 235.694 264.048Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.412,
    d: "M234.356 263.793C235.354 252.209 214.453 240.582 187.673 237.824C160.893 235.065 138.374 242.219 137.376 253.802C136.378 265.386 157.279 277.013 184.059 279.772C210.839 282.531 233.358 275.377 234.356 263.793Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.431,
    d: "M233.041 263.576C234.021 252.202 213.6 240.796 187.428 238.1C161.257 235.403 139.247 242.439 138.267 253.813C137.287 265.187 157.708 276.594 183.879 279.29C210.051 281.986 232.061 274.951 233.041 263.576Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.451,
    d: "M231.703 263.326C232.664 252.161 212.721 240.977 187.158 238.346C161.596 235.715 140.094 242.634 139.133 253.799C138.172 264.964 158.116 276.148 183.678 278.779C209.24 281.41 230.742 274.491 231.703 263.326Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.471,
    d: "M230.39 263.11C231.333 252.154 211.869 241.191 186.916 238.623C161.962 236.054 140.969 242.854 140.026 253.81C139.083 264.765 158.547 275.729 183.501 278.297C208.454 280.865 229.447 274.066 230.39 263.11Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M229.052 262.861C229.976 252.115 210.99 241.374 186.645 238.871C162.301 236.368 141.816 243.051 140.892 253.798C139.968 264.544 158.955 275.285 183.299 277.788C207.644 280.291 228.128 273.608 229.052 262.861Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M227.742 262.652C228.648 252.117 210.141 241.598 186.405 239.157C162.669 236.717 142.693 243.28 141.787 253.816C140.881 264.352 159.389 274.871 183.124 277.311C206.86 279.751 226.836 273.188 227.742 262.652Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.529,
    d: "M226.449 262.443C227.341 252.113 209.309 241.803 186.173 239.415C163.037 237.028 143.559 243.466 142.667 253.797C141.776 264.127 159.808 274.437 182.944 276.825C206.08 279.213 225.558 272.774 226.449 262.443Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.549,
    d: "M225.096 262.117C225.961 251.996 208.4 241.927 185.873 239.627C163.347 237.327 144.385 243.667 143.52 253.788C142.656 263.909 160.217 273.978 182.744 276.278C205.27 278.578 224.232 272.238 225.096 262.117Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.569,
    d: "M223.742 261.916C224.591 252.008 207.518 242.156 185.609 239.911C163.699 237.666 145.25 243.878 144.401 253.786C143.552 263.694 160.624 273.546 182.534 275.791C204.443 278.036 222.893 271.824 223.742 261.916Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.588,
    d: "M222.436 261.713C223.267 252.015 206.674 242.383 185.373 240.2C164.073 238.017 146.132 244.11 145.3 253.809C144.469 263.507 161.063 273.139 182.363 275.322C203.664 277.505 221.605 271.412 222.436 261.713Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.608,
    d: "M221.132 261.446C221.944 251.957 205.828 242.547 185.137 240.43C164.445 238.312 147.013 244.288 146.201 253.777C145.388 263.267 161.504 272.676 182.195 274.794C202.887 276.911 220.319 270.935 221.132 261.446Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.627,
    d: "M219.803 261.214C220.596 251.935 204.959 242.749 184.877 240.695C164.794 238.642 147.87 244.499 147.077 253.778C146.283 263.057 161.92 272.243 182.003 274.297C202.086 276.35 219.01 270.493 219.803 261.214Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.647,
    d: "M218.478 260.984C219.253 251.914 204.094 242.95 184.62 240.961C165.146 238.972 148.732 244.712 147.957 253.781C147.182 262.85 162.341 271.815 181.815 273.804C201.289 275.793 217.704 270.053 218.478 260.984Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M217.178 260.756C217.935 251.893 203.25 243.147 184.379 241.22C165.508 239.293 149.596 244.916 148.839 253.779C148.082 262.642 162.767 271.389 181.638 273.316C200.509 275.242 216.421 269.619 217.178 260.756Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.686,
    d: "M215.806 260.493C216.543 251.842 202.34 243.323 184.084 241.464C165.827 239.605 150.431 245.112 149.694 253.763C148.957 262.413 163.16 270.933 181.416 272.792C199.673 274.65 215.07 269.144 215.806 260.493Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.706,
    d: "M214.514 260.298C215.235 251.854 201.509 243.547 183.856 241.745C166.203 239.943 151.308 245.327 150.587 253.771C149.866 262.215 163.592 270.521 181.245 272.324C198.898 274.126 213.793 268.742 214.514 260.298Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.725,
    d: "M213.16 259.991C213.855 251.757 200.603 243.685 183.559 241.964C166.516 240.243 152.135 245.523 151.44 253.757C150.744 261.992 163.997 270.063 181.04 271.784C198.084 273.506 212.464 268.226 213.16 259.991Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.745,
    d: "M211.835 259.817C212.515 251.796 199.747 243.943 183.317 242.277C166.888 240.612 153.017 245.765 152.337 253.787C151.657 261.808 164.425 269.661 180.855 271.327C197.285 272.992 211.155 267.839 211.835 259.817Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.765,
    d: "M210.528 259.552C211.189 251.739 198.899 244.109 183.078 242.509C167.257 240.909 153.895 245.945 153.235 253.758C152.574 261.57 164.864 269.2 180.685 270.8C196.506 272.4 209.867 267.364 210.528 259.552Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.784,
    d: "M209.201 259.323C209.843 251.719 198.031 244.311 182.818 242.776C167.606 241.241 154.754 246.16 154.112 253.763C153.47 261.366 165.282 268.774 180.495 270.31C195.707 271.845 208.559 266.926 209.201 259.323Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.804,
    d: "M207.868 259.086C208.493 251.691 197.158 244.5 182.552 243.024C167.945 241.549 155.598 246.348 154.973 253.744C154.348 261.139 165.683 268.33 180.289 269.806C194.896 271.281 207.244 266.482 207.868 259.086Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.823,
    d: "M206.544 258.833C207.144 251.647 196.284 244.688 182.286 243.29C168.289 241.891 156.455 246.583 155.855 253.769C155.254 260.955 166.115 267.914 180.112 269.313C194.11 270.711 205.943 266.019 206.544 258.833Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.843,
    d: "M205.207 258.626C205.791 251.651 195.412 244.91 182.026 243.571C168.64 242.232 157.316 246.802 156.732 253.777C156.148 260.753 166.527 267.493 179.913 268.832C193.299 270.171 204.624 265.602 205.207 258.626Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.863,
    d: "M203.89 258.352C204.453 251.587 194.551 245.071 181.772 243.798C168.994 242.526 158.178 246.978 157.614 253.743C157.051 260.508 166.953 267.024 179.732 268.297C192.511 269.569 203.327 265.117 203.89 258.352Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.882,
    d: "M202.555 258.123C203.099 251.567 193.674 245.274 181.504 244.068C169.334 242.861 159.027 247.197 158.484 253.753C157.94 260.309 167.365 266.602 179.535 267.808C191.705 269.015 202.011 264.679 202.555 258.123Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    d: "M201.263 257.889C201.787 251.542 192.839 245.472 181.278 244.331C169.717 243.19 159.92 247.41 159.396 253.756C158.872 260.103 167.819 266.173 179.381 267.314C190.942 268.455 200.739 264.235 201.263 257.889Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.922,
    d: "M199.911 257.642C200.414 251.505 191.943 245.659 180.991 244.585C170.038 243.512 160.751 247.617 160.248 253.754C159.745 259.892 168.216 265.737 179.168 266.811C190.121 267.885 199.408 263.78 199.911 257.642Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.941,
    d: "M198.611 257.407C199.094 251.479 191.1 245.856 180.756 244.849C170.412 243.842 161.635 247.831 161.153 253.759C160.67 259.688 168.664 265.31 179.008 266.317C189.351 267.325 198.128 263.335 198.611 257.407Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.961,
    d: "M197.261 257.189C197.723 251.471 190.207 246.074 180.473 245.134C170.739 244.193 162.473 248.066 162.011 253.783C161.549 259.5 169.066 264.897 178.8 265.838C188.534 266.778 196.799 262.906 197.261 257.189Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M195.938 256.927C196.378 251.418 189.335 246.246 180.208 245.376C171.081 244.505 163.326 248.265 162.887 253.774C162.448 259.283 169.49 264.455 178.617 265.326C187.744 266.196 195.499 262.436 195.938 256.927Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.617 256.688C195.034 251.388 188.467 246.442 179.948 245.641C171.43 244.84 164.186 248.487 163.77 253.787C163.353 259.087 169.92 264.033 178.438 264.834C186.957 265.635 194.2 261.988 194.617 256.688Z",
    fill: "#0F0A26"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.02,
    d: "M321.292 135.205C322.655 119.422 292.163 103.367 253.187 99.3446C214.211 95.3223 181.511 104.856 180.149 120.639C178.786 136.422 209.278 152.477 248.254 156.499C287.23 160.522 319.93 150.988 321.292 135.205Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.039,
    d: "M319.972 134.978C321.316 119.406 291.304 103.573 252.937 99.6134C214.57 95.654 182.379 105.068 181.035 120.64C179.691 136.212 209.703 152.045 248.07 156.005C286.436 159.964 318.628 150.55 319.972 134.978Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.059,
    d: "M318.652 134.752C319.978 119.389 290.444 103.776 252.687 99.8797C214.93 95.9832 183.246 105.278 181.92 120.641C180.594 136.004 210.128 151.616 247.885 155.513C285.642 159.409 317.326 150.114 318.652 134.752Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.078,
    d: "M317.332 134.522C318.64 119.369 289.585 103.977 252.437 100.144C215.289 96.31 184.114 105.486 182.807 120.639C181.499 135.793 210.553 151.184 247.701 155.018C284.849 158.852 316.024 149.676 317.332 134.522Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.098,
    d: "M315.929 134.337C317.223 119.4 288.665 104.225 252.143 100.442C215.621 96.6589 184.965 105.701 183.671 120.638C182.377 135.575 210.935 150.75 247.457 154.533C283.979 158.316 314.635 149.274 315.929 134.337Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.118,
    d: "M314.61 134.109C315.886 119.382 287.807 104.427 251.894 100.707C215.98 96.9876 185.833 105.911 184.557 120.639C183.281 135.366 211.36 150.321 247.274 154.04C283.187 157.76 313.334 148.837 314.61 134.109Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.137,
    d: "M313.293 133.879C314.551 119.361 286.95 104.627 251.646 100.971C216.342 97.3139 186.703 106.119 185.445 120.637C184.187 135.155 211.788 149.889 247.092 153.546C282.396 157.202 312.035 148.397 313.293 133.879Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.157,
    d: "M311.976 133.654C313.215 119.346 286.094 104.835 251.398 101.241C216.703 97.6475 187.572 106.333 186.333 120.64C185.094 134.948 212.215 149.459 246.91 153.053C281.606 156.647 310.736 147.961 311.976 133.654Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.176,
    d: "M310.657 133.424C311.878 119.326 285.235 105.035 251.149 101.504C217.063 97.9738 188.44 106.54 187.219 120.639C185.998 134.737 212.64 149.028 246.727 152.558C280.813 156.089 309.435 147.522 310.657 133.424Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.196,
    d: "M309.321 133.138C310.522 119.249 284.358 105.182 250.88 101.718C217.402 98.2545 189.289 106.706 188.087 120.595C186.885 134.484 213.05 148.551 246.528 152.014C280.006 155.478 308.119 147.027 309.321 133.138Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.216,
    d: "M308.004 132.908C309.187 119.228 283.501 105.382 250.633 101.981C217.764 98.5809 190.159 106.914 188.975 120.593C187.792 134.273 213.477 148.119 246.346 151.52C279.215 154.92 306.82 146.587 308.004 132.908Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.235,
    d: "M306.687 132.68C307.852 119.21 282.646 105.585 250.386 102.247C218.126 98.9096 191.029 107.124 189.864 120.594C188.698 134.064 213.905 147.69 246.165 151.027C278.425 154.365 305.521 146.151 306.687 132.68Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.255,
    d: "M305.339 132.427C306.485 119.166 281.756 105.765 250.105 102.494C218.454 99.2227 191.866 107.321 190.72 120.582C189.574 133.843 214.303 147.245 245.955 150.516C277.606 153.787 304.193 145.688 305.339 132.427Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.275,
    d: "M304.024 132.203C305.152 119.152 280.902 105.972 249.86 102.764C218.818 99.5564 192.739 107.535 191.611 120.585C190.483 133.636 214.733 146.816 245.775 150.024C276.817 153.232 302.896 145.253 304.024 132.203Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.294,
    d: "M302.71 131.978C303.82 119.137 280.048 106.178 249.615 103.033C219.182 99.8876 193.611 107.748 192.501 120.589C191.391 133.429 215.163 146.389 245.596 149.534C276.029 152.679 301.6 144.819 302.71 131.978Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.314,
    d: "M301.365 131.728C302.456 119.097 279.162 106.36 249.338 103.281C219.513 100.202 194.451 107.945 193.361 120.577C192.27 133.209 215.563 145.945 245.388 149.024C275.212 152.104 300.274 144.36 301.365 131.728Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.333,
    d: "M300.05 131.501C301.123 119.079 278.309 106.563 249.093 103.547C219.877 100.53 195.324 108.155 194.251 120.578C193.179 133 215.993 145.516 245.209 148.532C274.424 151.549 298.978 143.924 300.05 131.501Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.353,
    d: "M298.738 131.277C299.793 119.064 277.457 106.769 248.851 103.815C220.244 100.862 196.199 108.368 195.144 120.581C194.09 132.794 216.425 145.089 245.032 148.042C273.638 150.996 297.683 143.49 298.738 131.277Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.373,
    d: "M297.393 131.028C298.428 119.025 276.571 106.953 248.573 104.065C220.575 101.178 197.039 108.568 196.004 120.572C194.968 132.575 216.826 144.647 244.824 147.535C272.821 150.422 296.358 143.032 297.393 131.028Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.392,
    d: "M296.08 130.806C297.097 119.013 275.719 107.163 248.33 104.339C220.941 101.514 197.913 108.784 196.896 120.577C195.879 132.37 217.257 144.22 244.646 147.045C272.035 149.87 295.063 142.599 296.08 130.806Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.412,
    d: "M294.738 130.559C295.736 118.975 274.835 107.348 248.055 104.589C221.275 101.83 198.756 108.984 197.758 120.568C196.76 132.152 217.66 143.779 244.441 146.538C271.221 149.296 293.739 142.142 294.738 130.559Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.431,
    d: "M293.43 130.335C294.41 118.96 273.988 107.554 247.817 104.858C221.646 102.162 199.635 109.197 198.655 120.571C197.675 131.946 218.097 143.352 244.268 146.048C270.439 148.744 292.45 141.709 293.43 130.335Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.451,
    d: "M292.087 130.089C293.048 118.924 273.105 107.74 247.543 105.11C221.98 102.479 200.479 109.397 199.517 120.562C198.556 131.727 218.5 142.911 244.062 145.542C269.625 148.173 291.126 141.255 292.087 130.089Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.471,
    d: "M290.779 129.868C291.722 118.912 272.258 107.949 247.304 105.381C222.351 102.813 201.358 109.612 200.415 120.568C199.472 131.524 218.936 142.487 243.889 145.055C268.843 147.623 289.836 140.824 290.779 129.868Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    d: "M289.441 129.624C290.365 118.878 271.379 108.137 247.034 105.634C222.689 103.132 202.205 109.814 201.281 120.561C200.357 131.308 219.343 142.048 243.688 144.551C268.033 147.054 288.517 140.371 289.441 129.624Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.51,
    d: "M288.136 129.408C289.041 118.872 270.534 108.353 246.798 105.913C223.063 103.473 203.087 110.036 202.181 120.572C201.275 131.107 219.782 141.626 243.518 144.067C267.254 146.507 287.23 139.944 288.136 129.408Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.529,
    d: "M286.838 129.204C287.73 118.874 269.697 108.563 246.561 106.176C223.426 103.788 203.947 110.227 203.056 120.558C202.164 130.888 220.197 141.198 243.333 143.586C266.468 145.973 285.946 139.534 286.838 129.204Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.549,
    d: "M285.488 128.88C286.352 118.759 268.791 108.69 246.264 106.39C223.738 104.09 204.776 110.43 203.912 120.551C203.047 130.672 220.608 140.741 243.135 143.041C265.661 145.341 284.623 139.001 285.488 128.88Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.569,
    d: "M284.13 128.687C284.98 118.779 267.907 108.927 245.998 106.682C224.088 104.436 205.639 110.648 204.79 120.556C203.94 130.464 221.013 140.316 242.922 142.562C264.832 144.807 283.281 138.595 284.13 128.687Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.588,
    d: "M282.832 128.472C283.663 118.773 267.069 109.141 245.769 106.958C224.468 104.775 206.527 110.868 205.696 120.567C204.865 130.265 221.458 139.897 242.759 142.08C264.059 144.263 282 138.17 282.832 128.472Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.608,
    d: "M281.513 128.199C282.326 118.71 266.21 109.301 245.519 107.183C224.827 105.065 207.395 111.041 206.582 120.531C205.77 130.02 221.886 139.429 242.577 141.547C263.269 143.665 280.701 137.689 281.513 128.199Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.627,
    d: "M280.187 127.97C280.98 118.691 265.343 109.505 245.26 107.451C225.178 105.398 208.254 111.255 207.461 120.534C206.667 129.812 222.304 138.999 242.387 141.052C262.47 143.106 279.393 137.248 280.187 127.97Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.647,
    d: "M278.863 127.737C279.637 118.667 264.478 109.703 245.005 107.714C225.531 105.725 209.116 111.465 208.341 120.534C207.566 129.604 222.725 138.568 242.199 140.557C261.673 142.546 278.088 136.806 278.863 127.737Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.667,
    d: "M277.564 127.51C278.321 118.647 263.636 109.9 244.765 107.973C225.894 106.046 209.982 111.669 209.225 120.532C208.469 129.395 223.153 138.142 242.024 140.069C260.896 141.996 276.807 136.373 277.564 127.51Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.686,
    d: "M276.191 127.256C276.927 118.605 262.725 110.086 244.468 108.227C226.212 106.369 210.815 111.875 210.078 120.526C209.342 129.177 223.544 137.696 241.801 139.555C260.057 141.413 275.454 135.907 276.191 127.256Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.706,
    d: "M274.902 127.056C275.623 118.612 261.898 110.306 244.245 108.503C226.592 106.701 211.697 112.085 210.976 120.529C210.255 128.973 223.981 137.28 241.634 139.082C259.286 140.884 274.181 135.5 274.902 127.056Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.725,
    d: "M273.546 126.759C274.242 118.525 260.989 110.454 243.946 108.732C226.902 107.011 212.522 112.291 211.826 120.525C211.13 128.76 224.383 136.831 241.427 138.552C258.47 140.274 272.85 134.994 273.546 126.759Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.745,
    d: "M272.228 126.576C272.908 118.554 260.14 110.701 243.711 109.036C227.281 107.37 213.41 112.523 212.73 120.545C212.05 128.566 224.818 136.419 241.248 138.085C257.678 139.75 271.548 134.597 272.228 126.576Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.765,
    d: "M270.912 126.308C271.573 118.495 259.283 110.865 243.462 109.265C227.641 107.665 214.28 112.701 213.619 120.513C212.958 128.326 225.248 135.956 241.069 137.556C256.89 139.156 270.251 134.12 270.912 126.308Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.784,
    d: "M269.587 126.078C270.229 118.475 258.417 111.067 243.205 109.532C227.992 107.997 215.14 112.916 214.498 120.519C213.857 128.122 225.668 135.53 240.881 137.066C256.093 138.601 268.945 133.682 269.587 126.078Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.804,
    d: "M268.253 125.852C268.877 118.456 257.543 111.265 242.936 109.79C228.329 108.314 215.982 113.114 215.357 120.509C214.733 127.905 226.067 135.096 240.674 136.571C255.28 138.047 267.628 133.247 268.253 125.852Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.823,
    d: "M266.935 125.592C267.535 118.405 256.675 111.446 242.678 110.048C228.68 108.65 216.846 113.341 216.246 120.527C215.645 127.713 226.506 134.673 240.503 136.071C254.501 137.469 266.335 132.778 266.935 125.592Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.843,
    d: "M265.6 125.387C266.184 118.411 255.805 111.671 242.419 110.332C229.033 108.993 217.709 113.562 217.125 120.538C216.541 127.513 226.92 134.253 240.306 135.593C253.692 136.932 265.017 132.362 265.6 125.387Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.863,
    d: "M264.274 125.115C264.837 118.35 254.935 111.834 242.156 110.561C229.378 109.289 218.562 113.741 217.998 120.506C217.435 127.271 227.337 133.787 240.116 135.06C252.894 136.332 263.71 131.88 264.274 125.115Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.882,
    d: "M262.941 124.889C263.485 118.333 254.06 112.04 241.89 110.833C229.72 109.627 219.414 113.963 218.87 120.519C218.326 127.075 227.751 133.367 239.921 134.574C252.091 135.781 262.398 131.444 262.941 124.889Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.902,
    d: "M261.647 124.642C262.171 118.296 253.223 112.226 241.662 111.084C230.101 109.943 220.304 114.163 219.78 120.51C219.256 126.856 228.204 132.926 239.765 134.067C251.326 135.209 261.123 130.989 261.647 124.642Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.922,
    d: "M260.298 124.406C260.801 118.268 252.33 112.422 241.377 111.348C230.425 110.275 221.138 114.38 220.635 120.517C220.132 126.655 228.602 132.501 239.555 133.574C250.508 134.648 259.794 130.543 260.298 124.406Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.941,
    d: "M258.995 124.163C259.478 118.235 251.484 112.612 241.14 111.605C230.796 110.598 222.02 114.587 221.537 120.515C221.054 126.444 229.048 132.066 239.392 133.073C249.736 134.081 258.513 130.091 258.995 124.163Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.961,
    d: "M257.654 123.949C258.116 118.232 250.6 112.835 240.866 111.895C231.132 110.954 222.866 114.827 222.404 120.544C221.942 126.261 229.459 131.658 239.193 132.599C248.927 133.539 257.192 129.667 257.654 123.949Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.98,
    d: "M256.327 123.687C256.766 118.178 249.724 113.007 240.597 112.136C231.47 111.266 223.715 115.026 223.276 120.535C222.836 126.044 229.879 131.216 239.006 132.086C248.132 132.957 255.887 129.196 256.327 123.687Z",
    fill: "#0F0A26"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.008 123.449C255.425 118.149 248.857 113.203 240.339 112.402C231.82 111.6 224.577 115.247 224.16 120.547C223.743 125.848 230.311 130.794 238.829 131.595C247.347 132.396 254.591 128.749 255.008 123.449Z",
    fill: "#0F0A26"
  }))), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M271.083 86.1158C264.865 82.7332 257.71 82.0317 251.04 84.1506C246.39 85.4206 243.063 89.1471 240.657 94.6719C237.671 102.701 235.846 111.189 235.245 119.832C232.239 147.666 233.241 185.232 223.338 209.035C206.743 248.794 182.901 288.199 148.095 282.633C134.506 280.441 126.61 274.875 122.559 268.299C119.941 263.928 118.751 258.718 119.18 253.515C119.609 248.311 121.634 243.419 124.925 239.631C126.03 238.445 127.337 237.507 128.773 236.87L148.616 250.381C149.211 248.261 149.149 245.985 148.438 243.908C147.727 241.831 146.409 240.069 144.687 238.897H144.647C144.125 238.451 143.56 238.068 142.962 237.757L142.513 237.494L65.5581 185.303C79.5876 171.713 90.7731 150.322 99.7524 128.845C115.626 90.7955 102.318 15.9281 126.291 9.30774C131.226 7.81382 136.442 7.84446 141.362 9.3962C144.567 10.4521 147.541 12.2125 150.101 14.5696L271.083 86.1158Z",
    fill: "url(#paint118_linear_6_1917)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M148.618 250.361L128.775 236.851C138.275 232.215 151.705 239.973 148.618 250.361Z",
    fill: "url(#paint119_linear_6_1917)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M286.676 118.247C284.953 130.697 267.516 139.946 259.258 134.291C257.448 133.03 256.133 131.077 255.569 128.813C251.525 114.039 261.823 107.465 261.823 107.465L240.656 94.667C243.062 89.1447 246.39 85.4181 251.04 84.1456C257.71 82.0265 264.865 82.7281 271.083 86.111L272.566 86.9879C283.149 93.962 288.08 108.428 286.676 118.247Z",
    fill: "url(#paint120_linear_6_1917)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M142.524 237.477C140.409 236.295 138.084 235.629 135.711 235.523C133.338 235.417 130.972 235.874 128.775 236.862C127.34 237.499 126.032 238.437 124.927 239.624C121.636 243.411 119.612 248.304 119.182 253.508C118.753 258.711 119.944 263.921 122.561 268.291L12.2817 194.124L12.0413 193.991C-4.35827 184.165 -1.38841 165.542 5.58704 158.178C11.0394 152.392 19.8974 153.444 24.9071 157.826L65.5557 185.31L142.524 237.477Z",
    fill: "url(#paint121_linear_6_1917)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M255.571 128.813C256.135 131.077 257.45 133.03 259.26 134.291L235.247 119.824C235.847 111.182 237.673 102.694 240.658 94.6646L261.825 107.463C261.825 107.463 251.52 114.039 255.571 128.813Z",
    fill: "url(#paint122_linear_6_1917)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M154.597 284.792C152.349 284.79 150.104 284.61 147.88 284.252C142.002 283.439 136.3 281.508 131.031 278.545C127.149 276.338 123.814 273.135 121.312 269.21C118.496 264.52 117.216 258.924 117.683 253.335C118.15 247.747 120.335 242.497 123.882 238.442C125.128 237.108 126.6 236.054 128.216 235.337L128.364 235.281C128.827 235.138 139.801 231.827 146.067 237.442C149.176 240.228 150.537 244.62 150.11 250.492L147.113 250.246C147.455 245.512 146.46 242.066 144.162 240.002C139.343 235.676 130.154 238.175 129.249 238.435C128.026 238.994 126.911 239.803 125.965 240.818C122.926 244.336 121.06 248.871 120.668 253.691C120.275 258.511 121.379 263.335 123.801 267.385C128.128 274.411 136.606 279.125 148.309 281.011C163.558 283.451 178.073 276.953 191.442 261.698C202.037 249.619 212.016 232.171 221.956 208.357L224.69 209.723C214.608 233.878 204.442 251.624 193.612 263.973C187.735 270.952 180.657 276.597 172.784 280.584C167.055 283.352 160.861 284.785 154.597 284.792Z",
    fill: "url(#paint123_linear_6_1917)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M224.72 209.708L221.983 208.348C228.984 191.523 230.435 167.884 231.839 145.023C232.392 136.018 232.915 127.513 233.766 119.633C234.971 108.087 236.732 99.9313 239.313 93.962C242.038 87.7052 245.864 83.8681 250.69 82.549C257.7 80.3677 265.2 81.1082 271.74 84.6272C274.243 85.8947 276.556 87.5731 278.596 89.6041C283.255 94.118 286.378 100.224 287.456 106.928C288.214 111.058 288.099 115.323 287.12 119.397C286.141 123.472 284.323 127.247 281.806 130.436C279.51 133.108 276.67 135.15 273.518 136.399C270.366 137.647 266.989 138.067 263.661 137.624C260.661 137.534 257.8 136.226 255.634 133.955C253.467 131.685 252.151 128.615 251.941 125.342C251.584 121.292 252.284 117.215 253.963 113.585C255.402 110.055 258.064 107.293 261.363 105.906L262.295 109.03C257.744 110.652 254.23 118.252 254.922 124.976C255.06 127.495 256.066 129.864 257.737 131.604C259.408 133.345 261.62 134.329 263.928 134.357C266.796 134.748 269.707 134.396 272.428 133.329C275.148 132.262 277.6 130.511 279.586 128.216C281.791 125.399 283.379 122.069 284.228 118.479C285.078 114.89 285.167 111.135 284.488 107.502C283.764 103.218 282.12 99.1827 279.691 95.7289C277.263 92.2752 274.118 89.5017 270.517 87.6365L270.394 87.5727C264.505 84.3695 257.727 83.7141 251.415 85.7376C247.443 86.8234 244.372 89.9751 242.022 95.3721C239.589 101 237.914 108.831 236.748 120.013C235.905 127.818 235.384 136.283 234.834 145.247C233.405 168.397 231.936 192.338 224.72 209.708Z",
    fill: "url(#paint124_linear_6_1917)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M223.839 117.019C221.937 120.737 218.786 123.499 215.055 124.72C205.648 127.287 194.757 115.732 191.365 99.6636C187.973 83.5955 195.447 71.1385 207.21 70.8118C208.191 70.7825 209.173 70.8284 210.148 70.9493C208.753 79.1963 208.489 87.6247 209.366 95.9567C215.021 104.235 217.937 108.485 223.839 117.019Z",
    fill: "#FFC700"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M223.454 78.4344C217.703 83.159 212.907 89.132 209.366 95.9788C208.489 87.6468 208.753 79.2184 210.148 70.9714C215.29 71.5176 220.049 74.1865 223.454 78.4344Z",
    fill: "url(#paint125_linear_6_1917)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M228.673 93.3503C229.351 101.602 227.661 109.879 223.837 117.031C217.935 108.487 215.019 104.257 209.367 95.9763C212.907 89.1293 217.703 83.1563 223.455 78.4319C226.617 82.6611 228.447 87.893 228.673 93.3503Z",
    fill: "#E26060"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M189.883 61.6857C169.792 50.0737 159.745 44.264 139.657 32.657C139.556 32.6059 139.467 32.5316 139.396 32.4388C139.324 32.3461 139.272 32.2373 139.243 32.1202C139.215 32.0031 139.21 31.8806 139.229 31.7611C139.248 31.6417 139.29 31.5282 139.354 31.4287L139.56 31.107C139.709 30.903 139.918 30.7619 140.152 30.7077C140.385 30.6535 140.629 30.6896 140.841 30.8098L191.037 59.7303C191.137 59.7847 191.225 59.8621 191.295 59.9568C191.365 60.0516 191.416 60.1617 191.444 60.2798C191.472 60.3978 191.476 60.5211 191.457 60.6411C191.437 60.7612 191.395 60.8753 191.332 60.9758L191.13 61.3172C190.999 61.5352 190.8 61.6932 190.57 61.7611C190.34 61.8291 190.096 61.8023 189.883 61.6857Z",
    fill: "#CACDE6"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M186.879 67.8393C162.154 53.4294 149.789 46.2219 125.068 31.8365C124.837 31.6981 124.662 31.4692 124.579 31.1959C124.496 30.9226 124.51 30.6249 124.619 30.3625L124.697 30.1832C124.754 30.0589 124.833 29.9485 124.929 29.8583C125.026 29.7682 125.138 29.7003 125.259 29.6588C125.38 29.6172 125.507 29.6029 125.634 29.6166C125.76 29.6304 125.882 29.6719 125.994 29.7387C150.705 44.0848 163.079 51.2799 187.804 65.653C188.036 65.7959 188.21 66.0293 188.29 66.3064C188.371 66.5836 188.352 66.8837 188.238 67.1465L188.159 67.3332C188.11 67.4627 188.037 67.5796 187.945 67.6764C187.852 67.7732 187.742 67.8478 187.621 67.8954C187.501 67.9431 187.373 67.9627 187.245 67.953C187.117 67.9433 186.992 67.9047 186.879 67.8393Z",
    fill: "#CACDE6"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M184.578 74.6537C159.866 60.1602 147.522 52.8987 122.826 38.4667C122.586 38.3076 122.401 38.0661 122.3 37.7798C122.199 37.4935 122.188 37.1786 122.268 36.8847L122.327 36.6832C122.358 36.5513 122.417 36.429 122.499 36.3257C122.58 36.2225 122.682 36.1409 122.797 36.0873C122.912 36.0338 123.036 36.0095 123.161 36.0166C123.285 36.0236 123.406 36.0619 123.515 36.1281C148.227 50.5455 160.583 57.797 185.295 72.2635C185.533 72.4248 185.715 72.6696 185.811 72.9581C185.906 73.2466 185.91 73.562 185.82 73.8529L185.76 74.0568C185.732 74.1908 185.676 74.3159 185.597 74.4227C185.518 74.5294 185.417 74.615 185.303 74.6726C185.189 74.7303 185.064 74.7585 184.939 74.7552C184.813 74.7519 184.69 74.7173 184.578 74.6537Z",
    fill: "#CACDE6"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M182.804 81.9988C158.153 67.4684 145.824 60.1751 121.18 45.7234C120.932 45.5467 120.738 45.2928 120.624 44.9945C120.51 44.6963 120.48 44.3673 120.539 44.0504L120.582 43.8318C120.592 43.6967 120.633 43.5666 120.701 43.4532C120.769 43.3398 120.862 43.2468 120.971 43.1826C121.08 43.1184 121.202 43.085 121.326 43.0856C121.45 43.0861 121.572 43.1206 121.681 43.1857C146.345 57.635 158.683 64.9185 183.357 79.4415C183.602 79.6178 183.792 79.8731 183.901 80.1721C184.009 80.4711 184.03 80.7994 183.961 81.112L183.914 81.3306C183.903 81.4674 183.862 81.5994 183.794 81.7146C183.726 81.8299 183.633 81.9248 183.523 81.991C183.413 82.0572 183.29 82.0924 183.164 82.0938C183.039 82.0952 182.915 82.0625 182.804 81.9988Z",
    fill: "#CACDE6"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M181.458 89.7711C156.874 75.2309 144.581 67.9253 120.009 53.4858C119.754 53.2957 119.554 53.0317 119.429 52.7236C119.304 52.4154 119.261 52.0753 119.303 51.7416C119.315 51.6483 119.322 51.6016 119.333 51.5107C119.423 50.8327 119.885 50.5109 120.359 50.7885C144.956 65.2329 157.265 72.5362 181.871 87.0763C182.125 87.2636 182.323 87.5269 182.442 87.8345C182.562 88.1422 182.598 88.4813 182.545 88.8106C182.53 88.904 182.523 88.9506 182.509 89.0415C182.408 89.7269 181.932 90.0561 181.458 89.7711Z",
    fill: "#CACDE6"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M180.449 97.8948C155.947 83.367 143.692 76.0613 119.203 61.6611C118.944 61.4606 118.737 61.1886 118.606 60.8728C118.474 60.5569 118.421 60.2085 118.452 59.863C118.452 59.7672 118.466 59.7181 118.472 59.6174C118.533 58.9074 118.973 58.5586 119.445 58.8362C143.964 73.2511 156.232 80.5592 180.764 95.092C181.02 95.2901 181.221 95.5612 181.347 95.8755C181.472 96.1899 181.516 96.5356 181.474 96.8754C181.474 96.9712 181.458 97.0203 181.447 97.121C181.375 97.8236 180.926 98.1749 180.449 97.8948Z",
    fill: "#CACDE6"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M168.846 99.8209C148.726 87.8748 138.664 81.8882 118.558 70.0625C118.32 69.8739 118.13 69.6218 118.006 69.3302C117.883 69.0387 117.83 68.7174 117.852 68.3971C117.863 68.2005 117.87 68.1022 117.881 67.9057C117.92 67.2425 118.304 66.9059 118.73 67.1688C138.862 79.0043 148.935 84.9982 169.077 96.9541C169.312 97.141 169.498 97.392 169.616 97.6822C169.735 97.9724 169.781 98.2913 169.751 98.6073C169.736 98.8014 169.729 98.8997 169.713 99.0986C169.664 99.7422 169.273 100.074 168.846 99.8209Z",
    fill: "#CACDE6"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M200.776 221.559C166.332 201.681 150.004 190.592 115.983 170.186C115.859 170.109 115.751 170.005 115.665 169.881C115.579 169.756 115.517 169.614 115.483 169.462C115.45 169.311 115.444 169.154 115.469 169C115.493 168.846 115.546 168.699 115.624 168.569C115.776 168.29 116.019 168.084 116.305 167.993C116.59 167.901 116.897 167.932 117.163 168.078C151.238 188.467 167.644 199.499 202.101 219.372C202.228 219.451 202.337 219.559 202.423 219.688C202.508 219.816 202.567 219.963 202.596 220.119C202.625 220.275 202.623 220.436 202.59 220.591C202.558 220.746 202.495 220.892 202.407 221.018C202.24 221.308 201.983 221.521 201.683 221.62C201.384 221.72 201.062 221.698 200.776 221.559Z",
    fill: "#CACDE6"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M196.678 227.818C161.749 207.254 127.651 185.101 92.6911 164.604C92.5664 164.532 92.4571 164.433 92.3701 164.312C92.2832 164.191 92.2206 164.051 92.1866 163.901C92.1527 163.752 92.1481 163.596 92.1731 163.445C92.1981 163.293 92.2522 163.149 92.3317 163.022C92.492 162.742 92.7413 162.537 93.0317 162.446C93.3221 162.356 93.633 162.386 93.9043 162.531C128.928 183.04 163.129 205.122 198.12 225.691C198.245 225.768 198.353 225.874 198.435 226.003C198.518 226.131 198.573 226.278 198.597 226.432C198.62 226.587 198.613 226.745 198.573 226.896C198.534 227.047 198.465 227.187 198.37 227.304C198.185 227.59 197.916 227.797 197.608 227.891C197.299 227.984 196.971 227.958 196.678 227.818Z",
    fill: "#CACDE6"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M192.304 233.917C157.587 213.391 123.83 191.048 89.0745 170.595C88.9505 170.525 88.8419 170.426 88.7563 170.305C88.6706 170.184 88.6099 170.045 88.5783 169.896C88.5467 169.747 88.5449 169.592 88.5732 169.442C88.6015 169.293 88.6591 169.151 88.742 169.028C88.9106 168.759 89.1616 168.564 89.4499 168.479C89.7382 168.394 90.0449 168.424 90.3146 168.564C125.136 189.034 159.022 211.307 193.816 231.856C193.94 231.932 194.046 232.039 194.126 232.167C194.206 232.295 194.258 232.442 194.277 232.595C194.296 232.749 194.283 232.906 194.238 233.053C194.192 233.2 194.117 233.334 194.016 233.443C193.817 233.716 193.542 233.909 193.233 233.995C192.924 234.08 192.598 234.053 192.304 233.917Z",
    fill: "#CACDE6"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M187.699 239.872C153.219 219.399 119.836 196.883 85.3138 176.494C85.191 176.424 85.084 176.325 85.0002 176.205C84.9164 176.084 84.8579 175.945 84.8289 175.797C84.8 175.649 84.8012 175.496 84.8326 175.348C84.864 175.201 84.9247 175.063 85.0105 174.944C85.1869 174.675 85.4438 174.483 85.7365 174.401C86.0292 174.318 86.3391 174.35 86.6123 174.492C121.209 194.903 154.729 217.36 189.292 237.853C189.415 237.928 189.519 238.034 189.597 238.162C189.675 238.29 189.724 238.436 189.74 238.589C189.755 238.742 189.737 238.897 189.687 239.04C189.637 239.184 189.556 239.312 189.451 239.415C189.241 239.685 188.959 239.875 188.643 239.957C188.328 240.039 187.998 240.009 187.699 239.872Z",
    fill: "#CACDE6"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M182.914 245.701C148.682 225.293 115.68 202.619 81.4004 182.303C81.2787 182.234 81.1729 182.136 81.0908 182.016C81.0087 181.896 80.9525 181.757 80.9264 181.61C80.9002 181.463 80.9048 181.311 80.9398 181.166C80.9748 181.021 81.0394 180.887 81.1286 180.773C81.3132 180.508 81.5749 180.321 81.8703 180.242C82.1657 180.162 82.477 180.195 82.7528 180.336C117.125 200.676 150.245 223.295 184.563 243.726C184.685 243.801 184.788 243.906 184.864 244.034C184.939 244.162 184.986 244.308 184.998 244.46C185.01 244.612 184.989 244.765 184.935 244.905C184.881 245.046 184.796 245.17 184.689 245.266C184.471 245.531 184.183 245.715 183.865 245.793C183.547 245.871 183.215 245.839 182.914 245.701Z",
    fill: "#CACDE6"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M178.001 251.43C144 231.087 111.373 208.252 77.3206 188.01C77.1998 187.942 77.095 187.844 77.0147 187.724C76.9343 187.604 76.8806 187.466 76.8575 187.319C76.8344 187.173 76.8426 187.023 76.8817 186.88C76.9207 186.738 76.9894 186.607 77.0824 186.499C77.2754 186.238 77.5419 186.055 77.8404 185.978C78.1388 185.901 78.4523 185.935 78.7314 186.074C112.858 206.34 145.61 229.12 179.688 249.484C179.809 249.557 179.911 249.663 179.986 249.79C180.061 249.917 180.105 250.063 180.115 250.214C180.126 250.365 180.101 250.516 180.045 250.654C179.988 250.792 179.901 250.913 179.791 251.005C179.568 251.266 179.276 251.447 178.956 251.523C178.637 251.599 178.303 251.566 178.001 251.43Z",
    fill: "#CACDE6"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M154.979 246.146C121.955 225.366 107.249 213.376 73.0569 193.618C72.9371 193.551 72.8335 193.453 72.7549 193.334C72.6764 193.214 72.625 193.076 72.6051 192.93C72.5851 192.784 72.5972 192.635 72.6402 192.496C72.6832 192.356 72.7559 192.23 72.8524 192.127C73.0549 191.871 73.3275 191.693 73.6297 191.619C73.932 191.546 74.248 191.581 74.5306 191.719C108.756 211.499 123.552 223.448 156.657 244.225C156.773 244.305 156.871 244.414 156.941 244.544C157.011 244.674 157.051 244.82 157.058 244.971C157.065 245.121 157.039 245.271 156.982 245.408C156.924 245.545 156.837 245.665 156.729 245.758C156.51 246.014 156.224 246.189 155.91 246.259C155.597 246.328 155.271 246.289 154.979 246.146Z",
    fill: "#CACDE6"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M219.936 156.038C209.045 149.669 203.6 146.458 192.702 140.009C192.527 139.871 192.389 139.684 192.301 139.469C192.213 139.253 192.179 139.016 192.201 138.781L192.288 137.676C192.327 137.185 192.614 136.939 192.929 137.123C203.831 143.574 209.279 146.792 220.175 153.169C220.35 153.307 220.489 153.494 220.576 153.71C220.664 153.925 220.697 154.163 220.673 154.397L220.581 155.496C220.545 155.977 220.253 156.223 219.936 156.038Z",
    fill: "#CACDE6"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M219.112 164.322C205.705 156.505 198.997 152.543 185.578 144.611C185.388 144.461 185.237 144.257 185.143 144.021C185.049 143.786 185.015 143.527 185.044 143.272C185.08 142.913 185.098 142.734 185.131 142.375C185.183 141.842 185.511 141.575 185.859 141.781C199.275 149.718 205.984 153.68 219.389 161.507C219.58 161.655 219.731 161.858 219.826 162.092C219.922 162.327 219.957 162.586 219.93 162.841C219.896 163.199 219.878 163.376 219.842 163.732C219.791 164.26 219.46 164.526 219.112 164.322Z",
    fill: "#CACDE6"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M218.187 172.445C204.759 164.641 198.038 160.681 184.597 152.751C184.409 152.607 184.262 152.408 184.173 152.177C184.084 151.946 184.055 151.692 184.091 151.444C184.138 151.098 184.161 150.924 184.208 150.575C184.276 150.059 184.615 149.801 184.963 150.008C198.393 157.937 205.108 161.897 218.526 169.704C218.715 169.848 218.864 170.047 218.956 170.278C219.048 170.509 219.08 170.764 219.047 171.013C219.004 171.362 218.984 171.534 218.939 171.883C218.876 172.394 218.537 172.647 218.187 172.445Z",
    fill: "#CACDE6"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M217.025 180.284C203.546 172.477 196.806 168.512 183.309 160.568C183.126 160.431 182.983 160.238 182.9 160.013C182.817 159.788 182.797 159.541 182.842 159.303C182.903 158.971 182.934 158.812 182.995 158.47C183.085 157.979 183.444 157.733 183.79 157.945C197.269 165.882 203.997 169.844 217.454 177.648C217.64 177.786 217.786 177.979 217.873 178.206C217.96 178.432 217.986 178.682 217.946 178.923C217.892 179.257 217.865 179.415 217.811 179.758C217.73 180.252 217.373 180.488 217.025 180.284Z",
    fill: "#CACDE6"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M215.542 187.764C201.982 179.935 195.195 175.953 181.62 167.977C181.439 167.851 181.3 167.665 181.225 167.445C181.149 167.226 181.14 166.986 181.199 166.761C181.28 166.449 181.321 166.292 181.399 165.977C181.413 165.876 181.448 165.78 181.502 165.697C181.557 165.614 181.629 165.547 181.712 165.5C181.795 165.454 181.887 165.43 181.981 165.43C182.074 165.431 182.166 165.456 182.249 165.503C195.793 173.465 202.564 177.439 216.09 185.259C216.271 185.388 216.411 185.576 216.492 185.796C216.572 186.015 216.589 186.256 216.54 186.487C216.472 186.806 216.436 186.963 216.367 187.28C216.356 187.38 216.323 187.475 216.272 187.558C216.22 187.642 216.151 187.71 216.07 187.757C215.989 187.805 215.899 187.83 215.807 187.832C215.715 187.833 215.624 187.81 215.542 187.764Z",
    fill: "#CACDE6"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M213.624 194.876C199.938 186.998 193.093 182.984 179.403 174.941C179.226 174.818 179.094 174.632 179.029 174.414C178.965 174.196 178.972 173.96 179.05 173.747C179.158 173.445 179.212 173.295 179.313 173.011C179.341 172.912 179.389 172.821 179.452 172.745C179.516 172.669 179.594 172.61 179.682 172.571C179.769 172.531 179.863 172.514 179.957 172.519C180.052 172.524 180.144 172.552 180.227 172.6C193.879 180.611 200.704 184.608 214.338 192.464C214.517 192.582 214.655 192.762 214.73 192.975C214.805 193.189 214.813 193.424 214.752 193.643C214.666 193.94 214.619 194.095 214.527 194.409C214.505 194.511 214.462 194.607 214.402 194.689C214.342 194.77 214.265 194.836 214.178 194.881C214.092 194.926 213.997 194.949 213.901 194.948C213.805 194.947 213.71 194.922 213.624 194.876Z",
    fill: "#CACDE6"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M204.941 198.438C193.585 191.854 187.924 188.506 176.606 181.795C176.445 181.687 176.327 181.517 176.274 181.319C176.222 181.121 176.239 180.909 176.322 180.724C176.471 180.372 176.547 180.196 176.691 179.842C176.723 179.75 176.772 179.667 176.836 179.598C176.899 179.529 176.975 179.475 177.058 179.439C177.142 179.404 177.231 179.388 177.321 179.393C177.41 179.397 177.498 179.422 177.578 179.466C188.885 186.148 194.54 189.481 205.871 196.045C206.034 196.155 206.156 196.326 206.212 196.526C206.269 196.726 206.258 196.942 206.181 197.133C206.042 197.497 205.972 197.679 205.83 198.04C205.8 198.134 205.753 198.219 205.69 198.291C205.628 198.363 205.552 198.42 205.468 198.457C205.384 198.495 205.293 198.513 205.202 198.51C205.111 198.506 205.022 198.482 204.941 198.438Z",
    fill: "#CACDE6"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M109.864 141.825C107.979 140.736 107.038 140.194 105.146 139.123C106.986 135.421 107.992 133.65 109.639 129.763L114.287 132.443C112.67 136.33 111.683 138.113 109.864 141.825Z",
    fill: "url(#paint126_linear_6_1917)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M117.459 146.232C115.577 145.136 114.636 144.589 112.742 143.498C115.943 137.688 118.417 131.435 120.099 124.907L124.707 127.587C123.057 134.126 120.62 140.395 117.459 146.232Z",
    fill: "url(#paint127_linear_6_1917)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M125.05 150.668C123.17 149.565 122.228 149.015 120.348 147.917C122.597 143.63 124.505 139.14 126.054 134.497L130.682 137.199C129.16 141.856 127.275 146.362 125.05 150.668Z",
    fill: "url(#paint128_linear_6_1917)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M132.632 155.129L127.935 152.363C130.559 147.311 132.676 141.964 134.247 136.413L138.866 139.115C137.323 144.684 135.232 150.053 132.632 155.129Z",
    fill: "url(#paint129_linear_6_1917)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M140.21 159.617L135.514 156.842C138.753 150.533 141.173 143.762 142.703 136.723L147.308 139.425C145.808 146.483 143.419 153.278 140.21 159.617Z",
    fill: "url(#paint130_linear_6_1917)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M147.783 164.098L143.09 161.312C146.882 153.762 149.528 145.589 150.923 137.111L155.52 139.813C154.155 148.311 151.542 156.512 147.783 164.098Z",
    fill: "url(#paint131_linear_6_1917)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M155.358 168.598L150.667 165.81C155.398 156.052 158.372 145.392 159.429 134.409L164.014 137.111C162.983 148.112 160.045 158.799 155.358 168.598Z",
    fill: "url(#paint132_linear_6_1917)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M162.927 173.101L158.236 170.311C165.09 154.712 166.498 145.959 168.093 126.169L172.676 128.886C171.075 148.664 169.758 157.419 162.927 173.101Z",
    fill: "url(#paint133_linear_6_1917)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M170.497 177.599L165.804 174.811C170.388 164.927 173.241 154.192 174.213 143.161L178.798 145.863C177.853 156.913 175.039 167.674 170.497 177.599Z",
    fill: "url(#paint134_linear_6_1917)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M125.387 93.6867C125.324 94.7528 124.713 95.2958 124.039 94.9003C123.663 94.5996 123.363 94.198 123.17 93.7342C122.977 93.2704 122.896 92.76 122.936 92.2521C122.999 91.1835 123.592 90.6357 124.266 91.0239C124.647 91.3243 124.951 91.7273 125.147 92.194C125.343 92.6606 125.426 93.1748 125.387 93.6867Z",
    fill: "url(#paint135_linear_6_1917)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M124.976 99.9436C124.897 101 124.284 101.533 123.61 101.138C123.237 100.841 122.942 100.443 122.754 99.9823C122.566 99.5219 122.492 99.0156 122.539 98.514C122.617 97.4577 123.213 96.9172 123.887 97.3127C124.262 97.609 124.561 98.0079 124.752 98.4695C124.943 98.9311 125.02 99.4392 124.976 99.9436Z",
    fill: "url(#paint136_linear_6_1917)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M159.393 114.523C146.486 106.866 140.034 103.039 127.135 95.4505C127.002 95.3445 126.897 95.2029 126.829 95.0394C126.761 94.8759 126.732 94.696 126.746 94.517C126.746 94.4925 126.746 94.4827 126.746 94.4581C126.769 94.0847 126.971 93.8906 127.216 94.0307C140.117 101.624 146.574 105.453 159.482 113.113C159.615 113.219 159.719 113.36 159.787 113.523C159.855 113.686 159.883 113.866 159.869 114.044C159.869 114.066 159.869 114.078 159.869 114.103C159.844 114.474 159.628 114.663 159.393 114.523Z",
    fill: "#CACDE6"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M158.941 120.731C146.046 113.089 139.599 109.266 126.713 101.698C126.581 101.593 126.477 101.453 126.411 101.291C126.344 101.129 126.317 100.951 126.333 100.774C126.333 100.752 126.333 100.74 126.333 100.715C126.36 100.344 126.576 100.155 126.812 100.293C139.7 107.866 146.15 111.688 159.045 119.335C159.176 119.44 159.279 119.58 159.346 119.742C159.412 119.904 159.438 120.083 159.422 120.259V120.318C159.395 120.684 159.177 120.871 158.941 120.731Z",
    fill: "#CACDE6"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0257 128.007L43.2767 95.3695C41.8066 94.3883 40.5653 93.047 39.6507 91.4512C38.736 89.8555 38.1731 88.0492 38.0063 86.1748V37.4718C38.0063 34.266 40.3652 33.1826 43.2767 35.0569L94.0257 67.6943C95.4958 68.6754 96.7371 70.0168 97.6518 71.6125C98.5664 73.2083 99.1294 75.0146 99.2961 76.889V125.59C99.2961 128.798 96.926 129.889 94.0257 128.007Z",
    fill: "#EDF0FC"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M91.6693 129.152L40.9203 96.5143C39.4502 95.5332 38.2089 94.1918 37.2942 92.5961C36.3796 91.0004 35.8166 89.194 35.6499 87.3196V38.6166C35.6499 35.4109 38.0088 34.3275 40.9203 36.1994L91.6693 68.8368C93.1392 69.8181 94.3804 71.1594 95.295 72.7551C96.2097 74.3508 96.7727 76.1571 96.9396 78.0315V126.732C96.9396 129.943 94.5807 131.024 91.6693 129.152Z",
    fill: "#E1E3EF"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M87.8614 122.17L44.7281 94.436C43.4783 93.6027 42.423 92.4629 41.6455 91.1067C40.868 89.7504 40.3897 88.215 40.2485 86.6218V45.2393C40.2485 42.515 42.2547 41.5962 44.7281 43.1856L87.8614 70.9197C89.1112 71.753 90.1666 72.8929 90.944 74.2491C91.7215 75.6054 92.1997 77.1408 92.3409 78.734V120.117C92.3341 122.841 90.3326 123.76 87.8614 122.17Z",
    fill: "#FCFCFE"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M85.9093 83.6765L52.8383 62.4079C52.6107 62.2555 52.4184 62.0475 52.2765 61.8004C52.1346 61.5532 52.0471 61.2734 52.0205 60.9831V60.8307C52.0205 60.3394 52.389 60.1675 52.8383 60.4574L85.9093 81.726C86.1369 81.8784 86.3291 82.0864 86.471 82.3335C86.6128 82.5807 86.7004 82.8603 86.727 83.1507V83.303C86.7247 83.7968 86.3586 83.9664 85.9093 83.6765Z",
    fill: "#E1E3EF"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8399 88.668L46.7503 63.5279C46.5035 63.3622 46.2952 63.1362 46.1417 62.8677C45.9881 62.5992 45.8935 62.2954 45.8652 61.9803C45.8652 61.4423 46.2628 61.2606 46.7503 61.575L85.8399 86.7151C86.0868 86.8803 86.2954 87.1057 86.4493 87.3737C86.6033 87.6418 86.6984 87.9452 86.7273 88.2601C86.725 88.7981 86.3274 88.9824 85.8399 88.668Z",
    fill: "#E1E3EF"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8399 93.7039L46.7503 68.564C46.5038 68.3985 46.2958 68.1729 46.1422 67.9048C45.9887 67.6368 45.8938 67.3335 45.8652 67.0187C45.8652 66.4808 46.2628 66.299 46.7503 66.6135L85.8399 91.7535C86.0871 91.919 86.2958 92.1447 86.4498 92.4132C86.6037 92.6818 86.6988 92.9856 86.7273 93.301C86.725 93.8341 86.3274 94.0183 85.8399 93.7039Z",
    fill: "#E1E3EF"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8399 98.7399L46.7503 73.5998C46.5037 73.4344 46.2955 73.2089 46.1419 72.9408C45.9884 72.6728 45.8937 72.3694 45.8652 72.0546C45.8652 71.519 46.2628 71.3349 46.7503 71.6493L85.8399 96.7894C86.0868 96.9546 86.2954 97.1801 86.4493 97.4482C86.6033 97.7162 86.6984 98.0195 86.7273 98.3344C86.725 98.87 86.3274 99.0543 85.8399 98.7399Z",
    fill: "#E1E3EF"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M85.8396 103.776L46.7501 78.6356C46.5032 78.4704 46.2947 78.2449 46.1407 77.9768C45.9868 77.7087 45.8916 77.4053 45.8628 77.0904C45.8628 76.5524 46.2603 76.3707 46.7501 76.6851L85.8396 101.825C86.0868 101.991 86.2955 102.217 86.4495 102.485C86.6035 102.754 86.6985 103.057 86.727 103.373C86.7248 103.906 86.3271 104.09 85.8396 103.776Z",
    fill: "#E1E3EF"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3832 104.658L46.676 83.6223C46.4496 83.4708 46.2582 83.264 46.1171 83.0181C45.976 82.7722 45.889 82.4939 45.8628 82.205V82.0428C45.8628 81.5515 46.229 81.382 46.676 81.6694L79.3832 102.705C79.6097 102.856 79.8008 103.063 79.9419 103.309C80.083 103.555 80.1702 103.833 80.1964 104.122V104.284C80.1942 104.78 79.8302 104.948 79.3832 104.658Z",
    fill: "#E1E3EF"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M341.729 231.478L290.981 198.841C289.511 197.86 288.269 196.518 287.354 194.922C286.44 193.327 285.877 191.52 285.71 189.646V140.948C285.71 137.74 288.069 136.659 290.981 138.531L341.729 171.168C343.199 172.149 344.441 173.49 345.356 175.086C346.27 176.682 346.833 178.488 347 180.363V229.063C347 232.269 344.641 233.338 341.729 231.478Z",
    fill: "#EDF0FC"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M339.375 232.623L288.626 199.985C287.156 199.004 285.914 197.662 285 196.066C284.085 194.47 283.522 192.663 283.356 190.788V142.09C283.356 138.884 285.715 137.803 288.626 139.675L339.375 172.313C340.845 173.294 342.087 174.635 343.001 176.231C343.916 177.827 344.479 179.633 344.646 181.507V230.205C344.646 233.414 342.287 234.495 339.375 232.623Z",
    fill: "#E1E3EF"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M335.561 225.639L292.427 197.905C291.178 197.071 290.123 195.931 289.346 194.575C288.568 193.219 288.091 191.683 287.95 190.09V148.708C287.95 145.984 289.956 145.065 292.427 146.654L335.561 174.388C336.81 175.222 337.865 176.362 338.643 177.718C339.42 179.074 339.899 180.609 340.04 182.203V223.583C340.042 226.312 338.032 227.228 335.561 225.639Z",
    fill: "#FCFCFE"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M333.615 187.147L300.544 165.879C300.316 165.727 300.124 165.519 299.982 165.271C299.84 165.024 299.753 164.745 299.726 164.454V164.302C299.726 163.811 300.095 163.639 300.544 163.928L333.615 185.197C333.842 185.349 334.035 185.557 334.176 185.804C334.318 186.052 334.406 186.331 334.433 186.622V186.774C334.433 187.268 334.064 187.437 333.615 187.147Z",
    fill: "#E1E3EF"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M333.545 192.139L294.456 166.999C294.209 166.834 294 166.608 293.846 166.34C293.692 166.071 293.597 165.767 293.568 165.452C293.568 164.914 293.966 164.732 294.456 165.046L333.545 190.187C333.792 190.352 334 190.577 334.154 190.845C334.307 191.113 334.402 191.417 334.43 191.731C334.43 192.269 334.033 192.454 333.545 192.139Z",
    fill: "#E1E3EF"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M333.545 197.175L294.456 172.035C294.209 171.87 294 171.644 293.846 171.375C293.692 171.107 293.597 170.803 293.568 170.488C293.568 169.95 293.966 169.768 294.456 170.082L333.545 195.222C333.792 195.388 334 195.614 334.154 195.882C334.307 196.151 334.402 196.455 334.43 196.77C334.43 197.305 334.033 197.49 333.545 197.175Z",
    fill: "#E1E3EF"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M333.545 202.211L294.456 177.071C294.209 176.906 294 176.68 293.846 176.411C293.692 176.143 293.597 175.839 293.568 175.524C293.568 174.988 293.966 174.804 294.456 175.118L333.545 200.258C333.792 200.423 334 200.649 334.154 200.917C334.307 201.185 334.402 201.489 334.43 201.803C334.43 202.341 334.033 202.531 333.545 202.211Z",
    fill: "#E1E3EF"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M333.545 207.247L294.456 182.107C294.209 181.942 294 181.716 293.846 181.448C293.692 181.18 293.597 180.877 293.568 180.562C293.568 180.024 293.966 179.842 294.456 180.154L333.545 205.294C333.792 205.459 334 205.685 334.154 205.953C334.307 206.221 334.402 206.525 334.43 206.839C334.43 207.377 334.033 207.562 333.545 207.247Z",
    fill: "#E1E3EF"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M327.088 208.131L294.382 187.096C294.155 186.945 293.964 186.738 293.823 186.492C293.682 186.246 293.595 185.968 293.568 185.679V185.517C293.568 185.025 293.935 184.856 294.382 185.143L327.088 206.178C327.315 206.33 327.506 206.537 327.647 206.783C327.788 207.029 327.875 207.307 327.902 207.596V207.758C327.9 208.252 327.536 208.419 327.088 208.131Z",
    fill: "#E1E3EF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_1917",
    x1: 176.426,
    y1: 118.507,
    x2: 330.106,
    y2: 118.507,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_1917",
    x1: 170.646,
    y1: 121.449,
    x2: 324.325,
    y2: 121.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_1917",
    x1: 216.978,
    y1: 181.992,
    x2: 309.481,
    y2: 107.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B3C6E5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DB2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_1917",
    x1: 310.1,
    y1: 228.912,
    x2: 136.903,
    y2: 253.041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6_1917",
    x1: 310.101,
    y1: 228.743,
    x2: 136.904,
    y2: 252.873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DCEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6_1917",
    x1: 71.0296,
    y1: 229.908,
    x2: 312.52,
    y2: 229.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DCEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6_1917",
    x1: 167.054,
    y1: 183.753,
    x2: 196.67,
    y2: 309.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6_1917",
    x1: 176.419,
    y1: 177.184,
    x2: 206.063,
    y2: 303.274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6_1917",
    x1: 212.729,
    y1: 151.73,
    x2: 242.375,
    y2: 277.808,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6_1917",
    x1: 198.818,
    y1: 161.503,
    x2: 228.451,
    y2: 287.549,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6_1917",
    x1: 208.198,
    y1: 154.9,
    x2: 237.861,
    y2: 281.001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6_1917",
    x1: 194.31,
    y1: 164.639,
    x2: 223.985,
    y2: 290.76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6_1917",
    x1: 203.687,
    y1: 158.07,
    x2: 233.375,
    y2: 284.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6_1917",
    x1: 171.297,
    y1: 180.776,
    x2: 200.961,
    y2: 306.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6_1917",
    x1: 175.843,
    y1: 177.589,
    x2: 205.508,
    y2: 303.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6_1917",
    x1: 185.212,
    y1: 171.035,
    x2: 214.85,
    y2: 297.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6_1917",
    x1: 184.652,
    y1: 171.427,
    x2: 214.306,
    y2: 297.513,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6_1917",
    x1: 193.995,
    y1: 164.86,
    x2: 223.649,
    y2: 290.947,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6_1917",
    x1: 175.598,
    y1: 177.768,
    x2: 205.305,
    y2: 303.892,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6_1917",
    x1: 180.108,
    y1: 174.6,
    x2: 209.759,
    y2: 300.703,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6_1917",
    x1: 189.459,
    y1: 168.035,
    x2: 219.124,
    y2: 294.143,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6_1917",
    x1: 184.958,
    y1: 171.188,
    x2: 214.673,
    y2: 297.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6_1917",
    x1: 166.464,
    y1: 184.116,
    x2: 196.187,
    y2: 310.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6_1917",
    x1: 171.016,
    y1: 180.96,
    x2: 200.696,
    y2: 307.09,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6_1917",
    x1: 175.277,
    y1: 177.983,
    x2: 204.939,
    y2: 304.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6_1917",
    x1: 163.965,
    y1: 185.942,
    x2: 193.5,
    y2: 312.03,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_6_1917",
    x1: 180.386,
    y1: 174.412,
    x2: 210.045,
    y2: 300.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_6_1917",
    x1: 189.744,
    y1: 167.855,
    x2: 219.374,
    y2: 293.913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_6_1917",
    x1: 199.113,
    y1: 161.263,
    x2: 228.778,
    y2: 287.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_6_1917",
    x1: 194.575,
    y1: 164.456,
    x2: 224.244,
    y2: 290.553,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_6_1917",
    x1: 180.666,
    y1: 174.221,
    x2: 210.295,
    y2: 300.262,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_6_1917",
    x1: 190.041,
    y1: 167.642,
    x2: 219.701,
    y2: 293.737,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_6_1917",
    x1: 138.957,
    y1: 203.456,
    x2: 168.594,
    y2: 329.531,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_6_1917",
    x1: 152.862,
    y1: 193.711,
    x2: 182.504,
    y2: 319.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_6_1917",
    x1: 143.49,
    y1: 200.277,
    x2: 173.166,
    y2: 326.401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_6_1917",
    x1: 157.398,
    y1: 190.527,
    x2: 187.059,
    y2: 316.609,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_6_1917",
    x1: 148.026,
    y1: 197.087,
    x2: 177.701,
    y2: 323.211,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_6_1917",
    x1: 161.944,
    y1: 187.338,
    x2: 191.616,
    y2: 313.456,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_6_1917",
    x1: 152.574,
    y1: 193.9,
    x2: 182.248,
    y2: 320.01,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_6_1917",
    x1: 166.768,
    y1: 183.959,
    x2: 196.432,
    y2: 310.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_6_1917",
    x1: 176.142,
    y1: 177.393,
    x2: 205.772,
    y2: 303.451,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_6_1917",
    x1: 185.492,
    y1: 170.819,
    x2: 215.154,
    y2: 296.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_6_1917",
    x1: 162.212,
    y1: 187.146,
    x2: 191.876,
    y2: 313.246,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_6_1917",
    x1: 171.585,
    y1: 180.576,
    x2: 201.205,
    y2: 306.614,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_6_1917",
    x1: 180.953,
    y1: 173.999,
    x2: 210.61,
    y2: 300.081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_6_1917",
    x1: 203.371,
    y1: 158.32,
    x2: 232.999,
    y2: 284.374,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_6_1917",
    x1: 207.909,
    y1: 155.129,
    x2: 237.546,
    y2: 281.193,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_6_1917",
    x1: 179.824,
    y1: 174.8,
    x2: 209.48,
    y2: 300.893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_6_1917",
    x1: 184.349,
    y1: 171.611,
    x2: 214.006,
    y2: 297.719,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_6_1917",
    x1: 193.717,
    y1: 165.054,
    x2: 223.379,
    y2: 291.151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_6_1917",
    x1: 188.911,
    y1: 168.415,
    x2: 218.581,
    y2: 294.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_6_1917",
    x1: 198.272,
    y1: 161.888,
    x2: 227.919,
    y2: 287.955,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_6_1917",
    x1: 212.449,
    y1: 151.946,
    x2: 242.104,
    y2: 278.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_6_1917",
    x1: 216.987,
    y1: 148.787,
    x2: 246.615,
    y2: 274.835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_6_1917",
    x1: 205.364,
    y1: 156.947,
    x2: 234.921,
    y2: 282.983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_6_1917",
    x1: 226.364,
    y1: 142.191,
    x2: 256.019,
    y2: 268.265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_6_1917",
    x1: 221.813,
    y1: 145.322,
    x2: 251.482,
    y2: 271.457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_6_1917",
    x1: 217.285,
    y1: 148.553,
    x2: 246.942,
    y2: 274.626,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_6_1917",
    x1: 148.31,
    y1: 196.883,
    x2: 177.954,
    y2: 322.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_6_1917",
    x1: 157.675,
    y1: 190.327,
    x2: 187.303,
    y2: 316.377,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_6_1917",
    x1: 189.182,
    y1: 168.237,
    x2: 218.846,
    y2: 294.336,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_6_1917",
    x1: 198.546,
    y1: 161.674,
    x2: 228.201,
    y2: 287.771,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C3C91"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_6_1917",
    x1: 167.054,
    y1: 182.863,
    x2: 196.658,
    y2: 308.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_6_1917",
    x1: 176.419,
    y1: 176.294,
    x2: 206.059,
    y2: 302.376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_6_1917",
    x1: 212.729,
    y1: 150.807,
    x2: 242.403,
    y2: 276.94,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_6_1917",
    x1: 198.818,
    y1: 160.609,
    x2: 228.455,
    y2: 286.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_6_1917",
    x1: 208.198,
    y1: 154.024,
    x2: 237.846,
    y2: 280.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_6_1917",
    x1: 194.31,
    y1: 163.761,
    x2: 223.973,
    y2: 289.858,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_6_1917",
    x1: 203.687,
    y1: 157.167,
    x2: 233.387,
    y2: 283.303,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_6_1917",
    x1: 171.297,
    y1: 179.894,
    x2: 200.947,
    y2: 305.956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_6_1917",
    x1: 175.843,
    y1: 176.692,
    x2: 205.523,
    y2: 302.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_6_1917",
    x1: 185.212,
    y1: 170.164,
    x2: 214.821,
    y2: 296.164,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_6_1917",
    x1: 184.652,
    y1: 170.518,
    x2: 214.319,
    y2: 296.631,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_6_1917",
    x1: 193.995,
    y1: 163.955,
    x2: 223.665,
    y2: 290.075,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_6_1917",
    x1: 175.593,
    y1: 176.876,
    x2: 205.293,
    y2: 303.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_6_1917",
    x1: 180.108,
    y1: 173.715,
    x2: 209.757,
    y2: 299.814,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_6_1917",
    x1: 189.459,
    y1: 167.144,
    x2: 219.126,
    y2: 293.256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_6_1917",
    x1: 184.958,
    y1: 170.307,
    x2: 214.661,
    y2: 296.443,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_6_1917",
    x1: 166.464,
    y1: 183.264,
    x2: 196.124,
    y2: 309.366,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_6_1917",
    x1: 171.016,
    y1: 180.08,
    x2: 200.68,
    y2: 306.179,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_6_1917",
    x1: 175.277,
    y1: 177.116,
    x2: 204.925,
    y2: 303.18,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_6_1917",
    x1: 163.965,
    y1: 185.048,
    x2: 193.505,
    y2: 311.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_6_1917",
    x1: 180.386,
    y1: 173.539,
    x2: 210.027,
    y2: 299.581,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_6_1917",
    x1: 189.744,
    y1: 166.966,
    x2: 219.374,
    y2: 293.024,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_6_1917",
    x1: 199.113,
    y1: 160.37,
    x2: 228.78,
    y2: 286.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_6_1917",
    x1: 194.575,
    y1: 163.57,
    x2: 224.23,
    y2: 289.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_6_1917",
    x1: 180.666,
    y1: 173.326,
    x2: 210.308,
    y2: 299.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_6_1917",
    x1: 190.041,
    y1: 166.757,
    x2: 219.685,
    y2: 292.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_6_1917",
    x1: 138.957,
    y1: 202.562,
    x2: 168.58,
    y2: 328.61,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_6_1917",
    x1: 152.862,
    y1: 192.82,
    x2: 182.518,
    y2: 318.912,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_6_1917",
    x1: 143.49,
    y1: 199.387,
    x2: 173.152,
    y2: 325.484,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_6_1917",
    x1: 157.398,
    y1: 189.638,
    x2: 187.059,
    y2: 315.72,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_6_1917",
    x1: 148.026,
    y1: 196.199,
    x2: 177.687,
    y2: 322.296,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_6_1917",
    x1: 161.944,
    y1: 186.454,
    x2: 191.602,
    y2: 312.545,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_6_1917",
    x1: 152.574,
    y1: 193.01,
    x2: 182.248,
    y2: 319.121,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_6_1917",
    x1: 166.768,
    y1: 183.067,
    x2: 196.451,
    y2: 309.204,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_6_1917",
    x1: 176.142,
    y1: 176.504,
    x2: 205.77,
    y2: 302.558,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_6_1917",
    x1: 185.492,
    y1: 169.931,
    x2: 215.151,
    y2: 295.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_6_1917",
    x1: 162.212,
    y1: 186.255,
    x2: 191.876,
    y2: 312.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_6_1917",
    x1: 171.585,
    y1: 179.685,
    x2: 201.219,
    y2: 305.75,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_6_1917",
    x1: 180.953,
    y1: 173.112,
    x2: 210.612,
    y2: 299.198,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_6_1917",
    x1: 203.371,
    y1: 157.428,
    x2: 233.001,
    y2: 283.486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_6_1917",
    x1: 207.909,
    y1: 154.263,
    x2: 237.531,
    y2: 280.295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_6_1917",
    x1: 179.824,
    y1: 173.896,
    x2: 209.494,
    y2: 300.016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_6_1917",
    x1: 184.349,
    y1: 170.728,
    x2: 214.002,
    y2: 296.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_6_1917",
    x1: 193.717,
    y1: 164.162,
    x2: 223.379,
    y2: 290.259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_6_1917",
    x1: 188.911,
    y1: 167.561,
    x2: 218.562,
    y2: 293.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_6_1917",
    x1: 198.272,
    y1: 161.008,
    x2: 227.915,
    y2: 287.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_6_1917",
    x1: 212.449,
    y1: 151.078,
    x2: 242.086,
    y2: 277.126,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_6_1917",
    x1: 217.003,
    y1: 147.89,
    x2: 246.64,
    y2: 273.935,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_6_1917",
    x1: 205.364,
    y1: 156.058,
    x2: 234.921,
    y2: 282.094,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_6_1917",
    x1: 226.364,
    y1: 141.273,
    x2: 256.034,
    y2: 267.379,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_6_1917",
    x1: 221.813,
    y1: 144.436,
    x2: 251.48,
    y2: 270.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_6_1917",
    x1: 217.285,
    y1: 147.653,
    x2: 246.946,
    y2: 273.735,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_6_1917",
    x1: 148.31,
    y1: 196.001,
    x2: 177.936,
    y2: 322.048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_6_1917",
    x1: 157.675,
    y1: 189.437,
    x2: 187.303,
    y2: 315.488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_6_1917",
    x1: 189.182,
    y1: 167.327,
    x2: 218.862,
    y2: 293.458,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_6_1917",
    x1: 198.546,
    y1: 160.784,
    x2: 228.201,
    y2: 286.882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#626EB2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.448,
    stopColor: "#8F92C7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCBEDD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_6_1917",
    x1: 103.169,
    y1: 24.7065,
    x2: 276.741,
    y2: 189.951,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DCEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_6_1917",
    x1: 134.336,
    y1: 232.948,
    x2: 140.947,
    y2: 253.898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DCEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_6_1917",
    x1: 251.063,
    y1: 83.1563,
    x2: 284.47,
    y2: 126.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B8BADB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DCEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_6_1917",
    x1: 80.2405,
    y1: 189.672,
    x2: 66.578,
    y2: 220.564,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DCEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_6_1917",
    x1: 257.386,
    y1: 103.779,
    x2: 236.754,
    y2: 117.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFBFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DCEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_6_1917",
    x1: 117.589,
    y1: 246.575,
    x2: 224.69,
    y2: 246.575,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DCEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_6_1917",
    x1: 221.983,
    y1: 145.514,
    x2: 287.951,
    y2: 145.514,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CED2E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D7DCEE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_6_1917",
    x1: 241.055,
    y1: 82.975,
    x2: 263.56,
    y2: 82.975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F58B21"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.593,
    stopColor: "#F5B419"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAD98A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_6_1917",
    x1: 109.717,
    y1: 148.048,
    x2: 109.717,
    y2: 132.381,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00306D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DB2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_6_1917",
    x1: 118.724,
    y1: 157.236,
    x2: 118.724,
    y2: 129.534,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00306D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DB2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_6_1917",
    x1: 125.515,
    y1: 159.013,
    x2: 125.515,
    y2: 138.006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00306D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DB2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_6_1917",
    x1: 133.4,
    y1: 164.787,
    x2: 133.4,
    y2: 140.475,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00306D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DB2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_6_1917",
    x1: 141.411,
    y1: 171.431,
    x2: 141.411,
    y2: 141.691,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00306D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DB2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_6_1917",
    x1: 149.305,
    y1: 178.024,
    x2: 149.305,
    y2: 142.967,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00306D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DB2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_6_1917",
    x1: 157.341,
    y1: 186.24,
    x2: 157.341,
    y2: 141.828,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00306D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DB2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_6_1917",
    x1: 165.456,
    y1: 197.318,
    x2: 165.456,
    y2: 136.354,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00306D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DB2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_6_1917",
    x1: 172.301,
    y1: 195.369,
    x2: 172.301,
    y2: 150.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00306D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DB2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_6_1917",
    x1: 122.926,
    y1: 92.9643,
    x2: 125.396,
    y2: 92.9643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DB2ED"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_6_1917",
    x1: 122.525,
    y1: 99.2256,
    x2: 124.988,
    y2: 99.2256,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#505FAA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1DB2ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/report.e844ea4710346bba061392ef107f545f.svg";
export { ForwardRef as ReactComponent };